class LocalCart { 
  constructor(storageKey = "localCart") {  
      this.storageKey = storageKey, this.cart = this._loadCart();
      //this.welcome25 = await updateWelcome25Row();

      this.welcome25 = false;
      this.additionalpromo = false;
      this.hasFlag = false;
      this.clubs = [ 
        "bluefit",
        "conditn",
        "bayfit_leisure_centre",
        "san_souci_leisure_centre",
        "lane_cove_swimming_pool",
        "windy_hill_fitness_centre",
        "belmont_oasis_leisure",
        "aquadome",
        "salisbury",
        "melton_waves",
        "laverton_swim_centre",
        "hurstville_aquatic_centre",
        "sans_souci_leisure_centre",
        "moss_vale_aquatic",
        "lockyer_valley_sports_aquatic_centre",
        "mount_annan",
        "oran_park",
        "the_pavilion_waca_grounds"
      ];  

      this.excludedTags_Global = ["keto_customers","NDIS","bluefit","conditn","T1","T2","T3","bayfit_leisure_centre","san_souci_leisure_centre","lane_cove_swimming_pool","windy_hill_fitness_centre","belmont_oasis_leisure","aquadome","salisbury","melton_waves","laverton_swim_centre","hurstville_aquatic_centre","sans_souci_leisure_centre","moss_vale_aquatic","lockyer_valley_sports_aquatic_centre","mount_annan","oran_park","the_pavilion_waca_grounds"];
      this.isExcluded_Global = userLoggedIn && typeof customerData !== 'undefined' && Array.isArray(customerData.tags) && customerData.tags.some(tag => this.excludedTags_Global.includes(tag));
      

      this.isBluefit = false; 

      if (userLoggedIn && Array.isArray(customerData.tags)){
        this.isBluefit = this.isBluefitUser(customerData.tags); 
      }

      console.log('isBluefit', this.isBluefit);

  }

  isBluefitUser(customertags) {
    if (!Array.isArray(customertags) || customertags.length === 0) {
      return false;
    }

    return customertags.some(tag =>
      this.clubs.includes(tag.trim().toLowerCase())
    );
  }

  _loadCart() {
      try { 

          const stored = localStorage.getItem(this.storageKey),
              parsed = stored ? JSON.parse(stored) : {};
          return {
              items: Array.isArray(parsed.items) ? parsed.items : [],
              attributes: Array.isArray(parsed.attributes) ? parsed.attributes : [],
              total_qty: parsed.total_qty || 0,
              item_count: parsed.item_count || 0,
              total_price: parsed.total_price || 0,
              original_total_price: parsed.total_price || 0,
              original_keto_total_price: parsed.original_keto_total_price || 0,
              original_t1_total_price: parsed.original_t1_total_price || 0,
              original_t2_total_price: parsed.original_t2_total_price || 0,
              original_t3_total_price: parsed.original_t3_total_price || 0
          } 
      } catch {
          return {
              items: [],
              total_qty: 0,
              item_count: 0,
              total_price: 0,
              original_total_price: 0,
              original_keto_total_price: 0,
              original_t1_total_price: 0,
              original_t2_total_price: 0,
              original_t3_total_price: 0,
              attributes: []
          }
      }
  }
  _saveCart() {
    
    this.cart.total_qty = this.cart.items.reduce((sum, item) => sum + item.qty, 0);
    this.cart.item_count = this.cart.items.reduce((sum, item) => sum + item.qty, 0);

    this.cart.total_price = this.cart.items.reduce((sum, item) => {
        if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")){          
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.keto_price;
          }
          return sum + item.qty * item.price;
        }else{
          return sum + item.qty * item.price;
        }
    }, 0);   

    this.cart.original_total_price = this.cart.items.reduce((sum, item) => {
        if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.keto_price;
          }
          return sum + item.qty * item.price;
        }else if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.t1_price;
          }
          return sum + item.qty * item.price;
        }else if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.t2_price;
          }
          return sum + item.qty * item.price;
        }else if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.t3_price;
          }
          return sum + item.qty * item.price;
        }else{
          return sum + item.qty * item.price;
        }
    }, 0);

    this.cart.original_keto_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.keto_price;
    }, 0);

    this.cart.original_t1_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.t1_price;
    }, 0);

    this.cart.original_t2_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.t2_price;
    }, 0);

    this.cart.original_t3_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.t3_price;
    }, 0);

    localStorage.setItem(this.storageKey, JSON.stringify(this.cart));
    // console.log(this.cart);
  }

  overwriteFromRemoteCart() {
    return fetch("/cart.json")
      .then(res => res.json())
      .then(data => {
        const cartLevelFrequency =
        (data?.attributes?.orderType && typeof data.attributes.orderType === "string")
          ? data.attributes.orderType
          : (data?.attributes?.orderType?.type || null);

        if (!Array.isArray(data.items) || data.items.length === 0 || !data.items[0].id) {
          this.cart = {
            items: [],
            total_qty: 0,
            item_count: 0,
            total_price: 0,
            original_total_price: 0,
            original_keto_total_price: 0,
            original_t1_total_price: 0,
            original_t2_total_price: 0,
            original_t3_total_price: 0,
            attributes: []
          };
        } else {
          const items = data.items.map(src => {
            // per-item selectedFrequency (preferred), else cart-level
            const itemProps = src.properties || {};
            const itemFrequency = itemProps.selectedFrequency || cartLevelFrequency || null;

            // choose selling plan by frequency
            let sellingPlan = null;
            if (itemFrequency === "WeeklySubscription") {
              sellingPlan = SELLING_PLAN_S;
            } else if (itemFrequency === "FortnightlySubscription") {
              sellingPlan = SELLING_PLAN_FS;
            }

            // ensure properties has selectedFrequency if we’re on a subscription
            const properties = {
              ...itemProps
              //...(itemFrequency ? { selectedFrequency: itemFrequency } : {})
            };

            return {
              product_id: src.product_id,
              variant_id: src.variant_id,
              title: src.title,
              url: src.url,
              image: src.image,
              price: src.original_price,     // cents
              keto_price: 1050,              // your fixed keto cents// cents
              t1_price: KETO_PRICE_T1,  // cents
              t2_price: KETO_PRICE_T2,  
              t3_price: KETO_PRICE_T3,
              qty: src.quantity,
              product_type: src.product_type,
              selling_plan: sellingPlan,              
              //qty_limit_enabled: qty_limit_enabled, 
              //max_qty_per_order: max_qty_per_order,  
              bf_true: src.bf_true,
              properties
            };
          });

          //console.log(items);

          this.cart = {
            items,
            total_qty: data.items.reduce((sum, item) => sum + item.quantity, 0),
            item_count: data.item_count,
            total_price: data.total_price,
            original_total_price: data.original_total_price,
            t1_total_price: data.t1_total_price,
            t2_total_price: data.t2_total_price,
            t3_total_price: data.t3_total_price,
            attributes: data.attributes || []
          };
        }
  
        this._saveCart(); // Save to localStorage
        
        return this.cart;
      })
      .catch(error => {
        console.error("Error overriding cart from remote:", error);
      });
  }

  getContractIdFromCache(email) {
    try {
      const cache = JSON.parse(localStorage.getItem('email_check_cache') || "{}");
      const data = cache[email]?.data;

      if (!data || !data.subscriptions) return null;

      // ✅ priority: active → paused
      if (Array.isArray(data.subscriptions.is_active) && data.subscriptions.is_active.length > 0) {
        return data.subscriptions.is_active[0].id.split("/").pop();
      }

      /*if (Array.isArray(data.subscriptions.is_paused) && data.subscriptions.is_paused.length > 0) {
        return data.subscriptions.is_paused[0].id.split("/").pop();
      }*/

      return null;

    } catch (e) {
      console.error("Error getting contractId from cache:", e);
      return null;
    }
  }

  updateReorderBox() {
    const reorderBox = document.querySelector("#re-order");
    const metaText = reorderBox?.querySelector("#re-order-muted");

    if (!reorderBox || !metaText || !LAST_ORDER) return;

    const items = Array.isArray(LAST_ORDER.items) ? LAST_ORDER.items : [];
    
    const totalMeals = items.reduce((sum, item) => {
      return sum + (parseInt(item.qty || item.quantity || 0, 10));
    }, 0);

    const orderDate = LAST_ORDER.created_at
      ? new Date(LAST_ORDER.created_at).toLocaleDateString("en-AU", {
          day: "numeric",
          month: "short",
          year: "numeric"
        })
      : "";

    metaText.textContent = `${totalMeals} meals • ordered ${orderDate}`;
    //reorderBox.style.display = totalMeals > 0 ? "flex" : "none";
    
  }


  updateTierDiscountCard() {
    const windowState = JSON.parse(localStorage.getItem("window_state") || "{}");
    const orderType = windowState.freq || "WeeklySubscription";
    const isSubscription = orderType !== "OneTimePurchase";

    let shipping_amount_get = (localStorage.getItem("shipping_amount") || 0);
    let shipping_aa = parseFloat(shipping_amount_get);
    const hasAddressnew = !!(windowState?.address && String(windowState.address).trim() !== "");  

    console.log('hasAddressnew', hasAddressnew);

    const offers = isSubscription ? promotionalOffers : oneTimeOffers;
    if (!offers) return;

    // Define standard tiers based on requirement: 10, 14, 20
    const TIERS = [
      { mealsRequired: 10, discountPercent: isSubscription ? 0 : 5 },
      { mealsRequired: 14, discountPercent: 10 },
      { mealsRequired: 20, discountPercent: 15 }
    ];

    const mealCount = this.countLunchAndDinnerMeals(this.cart.items);
    const cards = document.querySelectorAll(".discount-card");

    if (!cards.length) return;

    cards.forEach(cardEl => {

      const titleEl = cardEl.querySelector(".sub"); // Savings line
      const subEl = cardEl.querySelector(".tier-cta"); // Upsell prompt
      const ctaEl = cardEl.querySelector(".title"); // Upsell prompt primary
      const fillEl = cardEl.querySelector(".tier-fill");
      const dots = cardEl.querySelectorAll(".tier-dot");
      const labels = cardEl.querySelectorAll(".tier-labels span");

      // Dynamic Labels
      if (labels.length === 3) {
        labels.forEach((label, idx) => {
          const tier = TIERS[idx];
          if (tier) {
            const discText = (isSubscription && idx === 0) ? 'FREE DEL' : `${tier.discountPercent}%`;
            label.innerHTML = `${tier.mealsRequired} &middot; ${discText}`;

            if (idx === 0) {
              label.style.left = isSubscription ? 'calc(0% + 30px)' : 'calc(0% + 10px)';
            }
          }
        });
      }

      // A7: Currency formatting using class method (handles thousands separator and fixed decimals)
      const format = (cents) => this.formatMoney(cents);

      /* ---------- A2-A6: CURRENT & TARGET ---------- */
      const currentTier = [...TIERS].reverse().find(t => mealCount >= t.mealsRequired) || null;
      const targetTier = TIERS.find(t => mealCount < t.mealsRequired) || null;

      /* ---------- SAVINGS CALCULATION (A6: Mixed SKU support) ---------- */
      const lunchDinnerItems = this.cart.items.filter(item => item.product_type === "LUNCH & DINNER");
      let lunchDinnerTotalCents = lunchDinnerItems.reduce((sum, item) => sum + (item.price * item.qty), 0);
      
      // Handle special promo pricing if active
      if(this.additionalpromo && typeof PROMO_PROD_PRICE !== 'undefined'){
          lunchDinnerTotalCents = lunchDinnerItems.reduce((sum, item) => sum + (PROMO_PROD_PRICE * item.qty), 0);
      }
      
      let avgMealPriceCents = mealCount > 0 ? (lunchDinnerTotalCents / mealCount) : (this.additionalpromo ? PROMO_PROD_PRICE : 1295);

      let currentSavingsCents = 0;
      let currentSavingsCents25 = 0;
      let currentSavingsCentsWithOutShipping = 0;
      let currentSavingsCentsWithOutShipping25 = 0;
      let totalInCents = 0;
      if (currentTier) {
        let calculatedSavingsCents = 0;
        lunchDinnerItems.forEach(item => {
          let itemPrice = item.price;

          if (this.additionalpromo && typeof PROMO_PROD_PRICE !== 'undefined') {
            itemPrice = PROMO_PROD_PRICE;
          }

          let itemDiscount = (itemPrice / 100) * (currentTier.discountPercent / 100);

          // truncate to 2 decimals
          let finalDiscount = Math.floor(itemDiscount * 100) / 100;

          calculatedSavingsCents += finalDiscount * item.qty * 100;

          totalInCents  += itemPrice * item.qty;

        });
        calculatedSavingsCents = Math.round(calculatedSavingsCents.toFixed(2));

        currentSavingsCents = calculatedSavingsCents;
        currentSavingsCentsWithOutShipping = calculatedSavingsCents;
        
        console.log('currentSavingsCentsWithOutShipping',currentSavingsCentsWithOutShipping);
        console.log('currentSavingsCents',currentSavingsCents);

        // Add shipping savings for subscription tiers 10+
        if (isSubscription && mealCount >= 1 && hasAddressnew) {
          currentSavingsCents += Math.round(shipping_aa * 100);
        }

        totalInCents += Math.round(shipping_aa * 100);
      }

      /* ---------- UI MESSAGING (A2, A3, A4) ---------- */
      
      // A2/A3: Savings line
     
      if (currentSavingsCents > 0) {
        titleEl.textContent = `You're saving ${format(currentSavingsCents)} 🎉`;
        titleEl.style.display = "block";
      } else {
        titleEl.textContent = "";
        titleEl.style.display = "none";
      }

      // A4: Top tier handling & Rolling prompts (A3)
      if (!targetTier) {
        // Capped at top tier
        ctaEl.style.display = "none";
        subEl.textContent = "You've got the best deal!";
      } else {
        ctaEl.style.display = "block";
        const mealsNeeded = targetTier.mealsRequired - mealCount;

        // For subscriptions where the next tier has 0% discount (10-meal = free delivery only),
        // show a free delivery message with the shipping price instead of a misleading "$0 savings" message.
        let promptText;
        if (isSubscription && targetTier.discountPercent === 0) {
          if (shipping_aa > 0 && hasAddressnew) {
            promptText = `Add ${mealsNeeded} more meal${mealsNeeded > 1 ? 's' : ''} for Free Delivery (${format(Math.round(shipping_aa * 100))})`;
          } else {
            promptText = `Add ${mealsNeeded} more meal${mealsNeeded > 1 ? 's' : ''} for Free Delivery <span class="free-delivery-address-hint">*** Add your delivery address to unlock Free Delivery</span>`;
          }
        } else {
          // Calculate projected total savings at the next tier
          let nextProductSavingsCents = Math.round((targetTier.mealsRequired * avgMealPriceCents) * (targetTier.discountPercent / 100));
          let nextTotalSavingsCents = nextProductSavingsCents;
          if (isSubscription && targetTier.mealsRequired >= 1 && hasAddressnew) {
            nextTotalSavingsCents += Math.round(shipping_aa * 100);
          }
          promptText = `Add ${mealsNeeded} more meal${mealsNeeded > 1 ? 's' : ''} to save ${format(nextTotalSavingsCents)}`;
        }

        ctaEl.innerHTML = promptText;
        subEl.innerHTML = promptText;
      }

      // Update Total Discount Section in Mini Cart
      // Update Cart Discount + WELCOME25 Discount Section
      const totalDiscountWithShippingEl = document.querySelector(".total-discounts-with-shipping");      
      const totalDiscountAmountEl = document.querySelector(".total-discount-amount");
      const totalDiscountWithShippingAmountEl = document.querySelector(".total-discounts-with-shipping-amount");

      const welcomeDiscountWithShippingEl = document.querySelector(".welcome-discounts-with-shipping");
      const welcomeDiscountWithShippingAmountEl = document.querySelector(".welcome-discounts-with-shipping-amount");

      if (totalDiscountWithShippingAmountEl) {
        if (currentSavingsCentsWithOutShipping > 0) {
          totalDiscountWithShippingAmountEl.textContent = `${format(currentSavingsCentsWithOutShipping)}`;
          totalDiscountWithShippingEl?.classList.remove("d-none");
        } else {
          totalDiscountWithShippingAmountEl.textContent = "";
          totalDiscountWithShippingEl?.classList.add("d-none");
        }
      }

      if (totalDiscountAmountEl) {
        if (currentSavingsCents > 0) {
          totalDiscountAmountEl.textContent = `${format(totalInCents)}`;
          totalDiscountAmountEl?.classList.remove("d-none");
        } else {
          totalDiscountAmountEl.textContent = "";
          totalDiscountAmountEl?.classList.add("d-none");
        }
      }

      /* ---------- PROGRESS BAR ---------- */
      let progressPercent = 0;
      const t1 = TIERS[0].mealsRequired;
      const t2 = TIERS[1].mealsRequired;
      const t3 = TIERS[2].mealsRequired;

      if (mealCount < t1) {
        progressPercent = (mealCount / t1) * 33.33;
      } else if (mealCount < t2) {
        progressPercent = 33.33 + ((mealCount - t1) / (t2 - t1)) * 33.33;
      } else if (mealCount < t3) {
        progressPercent = 66.66 + ((mealCount - t2) / (t3 - t2)) * 33.34;
      } else {
        progressPercent = 100;
      }

      fillEl.style.width = `${Math.min(progressPercent, 100)}%`;

      /* ---------- DOTS ---------- */
      dots.forEach((dot, index) => {
        const tier = TIERS[index];
        if (tier) dot.classList.toggle("empty", mealCount < tier.mealsRequired);
      });
    });
  }

  reorderFromLastOrder(lastOrderItems = []) {

    if (!Array.isArray(lastOrderItems) || lastOrderItems.length === 0) {
      console.warn('No items to reorder');
      return;
    }
    
    let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

    let order__type = state_data.freq ? state_data.freq : "WeeklySubscription";
    let sellingPlan_n = SELLING_PLAN_S
    if (order__type == "WeeklySubscription") {
      sellingPlan_n = SELLING_PLAN_S;
    } else if (order__type == "FortnightlySubscription") {
      sellingPlan_n = SELLING_PLAN_FS;
    }

    // ✅ 1. Clear existing local cart
    this.cart = {
      items: [],
      total_qty: 0,
      item_count: 0,
      total_price: 0,
      original_total_price: 0,
      original_keto_total_price: 0,
      original_t1_total_price: 0,
      original_t2_total_price: 0,
      original_t3_total_price: 0,      
      attributes: {
        orderType: { type: order__type }
      }
    };

    // ✅ 2. Add items to local cart (NO API call)
    lastOrderItems.forEach(item => {

      this.cart.items.push({
        product_id: item.product_id,
        variant_id: item.variant_id,
        title: item.title,
        url: item.url || "#",
        image: item.image || "",
        price: item.price, // already in cents
        keto_price: item.keto_price || 1050,
        t1_price: item.t1_price || KETO_PRICE_T1,
        t2_price: item.t2_price || KETO_PRICE_T2,
        t3_price: item.t3_price || KETO_PRICE_T3,
        qty: item.qty || item.quantity || 1,
        product_type: item.product_type || "",
        selling_plan: sellingPlan_n
      });

    });

    // ✅ 3. Save to localStorage
    this._saveCart();

    console.log('✅ Reorder loaded into LocalCart');
  }

  handleReorderClick(items = window.LAST_ORDER?.items || []) {
    
    let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");
    let order__type = state_data.freq ? state_data.freq : "WeeklySubscription";
    let sellingPlan_n = SELLING_PLAN_S
    if (order__type == "WeeklySubscription") {
      sellingPlan_n = SELLING_PLAN_S;
    } else if (order__type == "FortnightlySubscription") {
      sellingPlan_n = SELLING_PLAN_FS;
    }

    try {
      if (!items.length) {
        const ItemsNEW = LAST_ORDER.items.map(item => ({
          product_id: item.product_id,
          variant_id: item.variant_id,
          title: item.title,
          url: item.url,
          image: item.image,
          price: item.price,            // already in cents
          keto_price: item.keto_price,
          t1_price: item.t1_price,
          t2_price: item.t2_price,
          t3_price: item.t3_price,
          qty: item.qty,
          product_type: item.product_type,
          selling_plan: sellingPlan_n
        }));

        items = ItemsNEW;
      }  

      console.log('lastOrderItems', LAST_ORDER);    

      // ✅ reorder
      const newCart = this.reorderFromLastOrder(items);

      // ✅ update UI
      this.updateCartInfoFromLocal(".cart-item-loop");

      console.log("✅ Reorder success", newCart);

    } catch (err) {
      console.error("❌ Reorder failed", err);
    }
  }

  async overwriteFromSubscriptionCache(email) {

    try {

      const EMAIL_CACHE_TTL = 30 * 1000; // 1 minute

      const cache = JSON.parse(
        localStorage.getItem("email_check_cache") || "{}"
      );

      const entry = cache[email];

      let data = null;

      // ✅ USE CACHE FIRST + CHECK EXPIRY
      if (entry?.data?.subscriptions) {

        const isExpired =
          (Date.now() - entry.checkedAt) > EMAIL_CACHE_TTL;

        if (!isExpired) {

          console.log("Loaded from cache");

          data = entry.data;

        } else {

          console.log("Cache expired");
        }
      }

      // ✅ API CALL IF CACHE NOT FOUND OR EXPIRED
      if (!data) {

        console.log("Calling API");

        const response = await fetch(
          "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/customers/find",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ email })
          }
        );

        data = await response.json();

        if (!data || !data.subscriptions) {
          return null;
        }

        // ✅ SAVE CACHE
        cache[email] = {
          data,
          checkedAt: Date.now()
        };

        localStorage.setItem(
          "email_check_cache",
          JSON.stringify(cache)
        );
      }

      // ✅ UI
      //if (data.subscriptions.is_available) {
      if (data?.subscriptions?.is_active?.length > 0) {

        document.querySelector(
          "#pre_selected_data_wrap"
        ).style.display = "none";

      } else {

        document.querySelector(
          "#pre_selected_data_wrap"
        ).style.display = "block";
      }

      let subs = data.subscriptions;

      // ✅ PRIORITY: ACTIVE → PAUSED
      let selectedSub = null;
      let type = null;

      if (
        Array.isArray(subs.is_active) &&
        subs.is_active.length > 0
      ) {

        selectedSub = subs.is_active[0];
        type = "active";

      }else {

        return null;
      }

      let subType = selectedSub.subscriptionType || {};

      let interval = subType.interval;
      let count = subType.intervalCount;

      let frequency_n = "WeeklySubscription";
      let sellingPlan_n = SELLING_PLAN_S;

      if (interval === "WEEK" && count === 2) {

        frequency_n = "FortnightlySubscription";
        sellingPlan_n = SELLING_PLAN_FS;
      }

      const contractId =
        selectedSub.id.split("/").pop();

      const items = (selectedSub.lineItems || []).map(src => {

        let variantId = Number(
          src.variantId.split("/").pop()
        );

        let productId = Number(
          src.productId.split("/").pop()
        );

        return {
          product_id: productId,
          variant_id: variantId,
          title: src.title,
          title: src.title,
          url: "#",
          image: src.image || "",
          price: Math.round(
            parseFloat(src.price) * 100
          ),
          keto_price: 1050,
          t1_price: KETO_PRICE_T1,
          t2_price: KETO_PRICE_T2,
          t3_price: KETO_PRICE_T3,
          qty: src.quantity,
          product_type: "LUNCH & DINNER",
          selling_plan: sellingPlan_n,
          subscription_contract_id: contractId,
          subscription_type: type,
          properties: {
            selectedFrequency: frequency_n
          }
        };

      });

      // ✅ BUILD CART
      this.cart = {
        items,
        total_qty: items.reduce(
          (sum, i) => sum + i.qty,
          0
        ),
        item_count: items.reduce(
          (sum, i) => sum + i.qty,
          0
        ),
        total_price: items.reduce(
          (sum, i) => sum + (i.price * i.qty),
          0
        ),
        original_total_price: items.reduce(
          (sum, i) => sum + (i.price * i.qty),
          0
        ),
        original_keto_total_price: 0,
        original_t1_total_price: 0,
        original_t2_total_price: 0,
        original_t3_total_price: 0,
        attributes: {
          orderType: {
            type: frequency_n
          }
        }
      };

      this._saveCart();

      console.log("Loaded subscription:", type);

      return this.cart;

    } catch (error) {

      console.error(
        "Error overriding from subscription cache:",
        error
      );

      return null;
    }
  }
  
  
  customaddToCart(variantId, quantity, selling_plan=null) {
    var formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity,
        'selling_plan': selling_plan
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cartData => { // Renamed to cartData to avoid conflicts
        // console.log('Success:', cartData);
        getCartData()
          .then(data => {
            this.updateCartInfoFromLocal('.cart-item-loop');
          })
          .catch(error => {
            console.error('Error getting cart data:', error);
          });
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }


  addItem(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan = null, qty_limit_enabled, max_qty_per_order, $productQuantityAction = null, bf_true) {    
    let index;
    const ketoPrice = KETO_PRICE;
    
    //alert(bf_true);

    let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

    console.log('deliveryInfoNew1=>',deliveryInfoNew);

    console.log('state_data1=>',state_data); 
    let new_step = parseInt(state_data.step || 0, 10);

    if (Object.keys(state_data).length === 0 || (new_step < 2)) { 

      document.querySelector('.cart-count')?.click();

    }

    selling_plan ? index = this.cart.items.findIndex(item => item.variant_id === variantId && item.selling_plan === selling_plan) : index = this.cart.items.findIndex(item => item.variant_id === variantId), index !== -1 ? (this.cart.items[index].qty += qty, this.cart.items[index].qty <= 0 && this.cart.items.splice(index, 1)) : this.cart.items.push({
        product_id: productId,
        variant_id: variantId,
        title,
        url,
        image,
        price,
        compare_at_price:  product_type === "LUNCH & DINNER" ? (compare_at_price || price) : (compare_at_price || price),
        keto_price: ketoPrice,        
        t1_price: KETO_PRICE_T1,  // cents
        t2_price: KETO_PRICE_T2,  
        t3_price: KETO_PRICE_T3,
        qty,
        product_type,
        selling_plan,
        qty_limit_enabled,
        max_qty_per_order,
        bf_true
    }), this._saveCart();
    this.updateCartInfoFromLocal('.cart-item-loop');   
  }

  addItemCondition(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan = null, qty_limit_enabled, max_qty_per_order, $productQuantityAction = null, produc_postcol = null, acknowledge_message = null, bf_true) {    
    
    let index;
    const ketoPrice = KETO_PRICE;
    const validAddress = localStorage.getItem("widgetAddress");     
    this.addItem(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan, qty_limit_enabled, max_qty_per_order, null, bf_true);
  }

  updateItem(productId, variantId, title, url, image, price, compare_at_price, qty, product_type, selling_plan = null, $productQuantityAction = null) {
      let index;
      let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

      console.log('deliveryInfoNew2=>',deliveryInfoNew);

      console.log('state_data2=>',state_data);
      let new_step = parseInt(state_data.step || 0, 10);

      if (Object.keys(state_data).length === 0 || (new_step < 2)) { 

        document.querySelector('.cart-count')?.click();

      }

      compare_at_price = product_type === "LUNCH & DINNER" ? (compare_at_price || 1295) : (compare_at_price || price);

      selling_plan ? index = this.cart.items.findIndex(item => item.variant_id === variantId && item.selling_plan === selling_plan) : index = this.cart.items.findIndex(item => item.variant_id === variantId), index !== -1 && (this.cart.items[index].qty = qty, this.cart.items[index].compare_at_price = compare_at_price, this.cart.items[index].qty <= 0 && this.cart.items.splice(index, 1)), this._saveCart(), $productQuantityAction?.removeClass("loading")
  }
  changeInToLocalCart(variantId, qty, $productQuantityAction = null) {
      console.log('removed');
      $productQuantityAction && $productQuantityAction?.addClass("loading"), this.updateItem(null, variantId, null, null, null, null, null, qty, null, null, $productQuantityAction)
      localCart.updateCartInfoFromLocal(".cart-item-loop")
  }
  clearCartDataLocal() {
      this.cart = {
          items: [],
          total_qty: 0,
          item_count: 0,
          total_price: 0,
          original_total_price: 0,
          original_keto_total_price: 0,
          original_t1_total_price: 0,
          original_t2_total_price: 0,
          original_t3_total_price: 0
      }, localStorage.removeItem(this.storageKey);
      this.updateCartInfoFromLocal(".cart-item-loop");
      clearCartData();
  }
  countLunchAndDinnerMeals(items = this.cart.items) {
      return Array.isArray(items) ? items.reduce((total_count, item) => item.product_type === "LUNCH & DINNER" ? total_count + (parseInt(item.qty || item.quantity, 10) || 0) : total_count, 0) : 0
  }
  getApplicableDiscountPercent(mealsCount, offers, minMeals = 0) {
    if (!offers || mealsCount < minMeals) return 0;
    
    let bestDiscount = 0;
    let highestMin = -1;

    Object.values(offers).forEach(offer => {
      const { min } = offer.mealRange || {};
      if (typeof min === 'number' && mealsCount >= min && min > highestMin) {
        highestMin = min;
        bestDiscount = offer.discounts;
      }
    });

    return bestDiscount;
  }
  validatedAddress() {
      const validAddress = localStorage.getItem("widgetAddress");
      if (validAddress !== null) {
          const addressResponse = JSON.parse(validAddress),
              {
                  address_line_combined,
                  locality_name,
                  state_territory,
                  postcode
              } = addressResponse;
          return Object.fromEntries(Object.entries({
              "checkout[shipping_address][country]": "AU",
              "checkout[shipping_address][address1]": address_line_combined,
              "checkout[shipping_address][city]": locality_name,
              "checkout[shipping_address][province]": state_territory,
              "checkout[shipping_address][zip]": postcode
          }).filter(([_, value]) => value))
      }
      return !1
  }

  hasDeliveryAndAddressFilled(orderType) {
    const windowState = JSON.parse(localStorage.getItem("window_state") || "{}");
    const widgetAddress = JSON.parse(localStorage.getItem("widgetAddress") || "{}");
    const deliveryInfo = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    const addressFilled = !!(widgetAddress.address_line_combined || windowState.address) &&
      !!(widgetAddress.locality_name || windowState.suburb) &&
      !!(widgetAddress.state_territory || windowState.state) &&
      !!(widgetAddress.postcode || windowState.postcode);
    if (orderType === "OneTimePurchase") {
      return !!addressFilled;
    }
    const v = (val) => (typeof val === "string" ? val.trim() !== "" : val !== undefined && val !== null && (Array.isArray(val) ? val.length > 0 : !!val));
    const deliveryFilled = v(deliveryInfo.deliveryDate) && v(deliveryInfo.deliveryStart) &&
      v(deliveryInfo.deliveryEnd) && v(deliveryInfo.packingDate);
    return !!addressFilled && !!deliveryFilled;
  }
  openMiniCartToDeliveryStep(message) {
    if (typeof window.openMiniCartToDeliveryStep === "function") {
      window.openMiniCartToDeliveryStep(message);
    } else {
      document.querySelector(".cart-count")?.click();
    }
  }
  
  openMiniCartToDeliveryStep(message) {
    if (typeof window.openMiniCartToDeliveryStep === "function") {
      window.openMiniCartToDeliveryStep(message);
    } else {
      document.querySelector(".cart-count")?.click();
    }
  }
  
  getCartData() {
      return {
          items: this.cart.items.map(item => ({
              id: item.variant_id,
              product_id: item.product_id,
              variant_id: item.variant_id,
              title: item.title,
              image: item.image,
              price: item.price,
              keto_price: KETO_PRICE,   
              compare_at_price:  item.product_type === "LUNCH & DINNER" ? (item.compare_at_price || 1295) : (item.compare_at_price || item.price), 
              t1_price: KETO_PRICE_T1,  // cents
              t2_price: KETO_PRICE_T2,  
              t3_price: KETO_PRICE_T3,
              quantity: item.qty,
              selling_plan: item.selling_plan || null,
              qty_limit_enabled: item.qty_limit_enabled, 
              max_qty_per_order: item.max_qty_per_order,               
              bf_true: item.bf_true,
              url: item.url || "#",
              properties: item.properties || {},
              product_type: item.product_type || ""
          })),
          original_total_price: this.cart.original_total_price || 0,
          original_keto_total_price: this.cart.original_keto_total_price || 0,
          original_t1_total_price: this.cart.original_t1_total_price || 0,
          original_t2_total_price: this.cart.original_t2_total_price || 0,
          original_t3_total_price: this.cart.original_t3_total_price || 0,
          total_price: this.cart.total_price,
          total_count: this.cart.total_qty,
          item_count: this.cart.item_count,
          attributes: JSON.parse(localStorage.getItem("cartAttributes") || "{}")
      }
  }    
  
  formatWithDelimiters(cents, precision = 2, thousands = ',', decimal = '.') { 
    if (cents == null || isNaN(cents)) return (0).toFixed(precision);

    // Convert "cents" to dollars
    const negative = Number(cents) < 0;
    const absoluteCents = Math.abs(Number(cents));
    const amount = (absoluteCents / 100).toFixed(precision);

    const [intPart, decPart = ''] = amount.split('.');
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (negative ? '-' : '') + withThousands + (precision ? decimal + decPart : '');
    
  }

  formatMoney(cents, format = "$") {
    // Accept strings like "1,195", "1195", "1195.00", "-1195"
    if (typeof cents === 'string') {
      // keep digits and optional leading minus
      const cleaned = cents.replace(/(?!^-)[^\d]/g, '');
      cents = Number(cleaned);
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    let formatString = format || "$";
    const match = placeholderRegex.exec(formatString);

    // Determine the token (e.g., "amount", "amount_with_comma_separator")
    // and whether the caller passed a full template ("$")
    // or just the token ("amount").
    const hasBraces = !!match;
    const token = hasBraces
      ? match[1]
      : (/^\w+$/.test(formatString) ? formatString : "amount");

    // Compute the formatted value based on the token
    let value;
    switch (token) {
      case 'amount':
        value = this.formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = this.formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = this.formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = this.formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = this.formatWithDelimiters(cents, 2);
    }

    // If the caller gave a template with , replace it.
    // If they passed only the token, return just the value.
    let result = hasBraces ? formatString.replace(placeholderRegex, value) : value;

    // Ensure it starts with $ if not already present
    if (!result.startsWith('$')) {
      result = '$' + result;
    }
    return result;
  }

  isShippingDeductedForTotal(orderType, mealsCount) {
    const shippingAmount = parseFloat(localStorage.getItem("shipping_amount") || 0);
    const windowState = JSON.parse(localStorage.getItem("window_state") || "{}");
    const hasAddress = !!(windowState?.address && String(windowState.address).trim() !== "");
    const isNDISCustomer = userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS");

    if (!shippingAmount || !hasAddress) return false;
    if (isNDISCustomer) return true;

    return ["WeeklySubscription", "FortnightlySubscription"].includes(orderType) && mealsCount >= 10;
  }

  updateTotalDiscountAmount(baseAmountDollars, showAmount = false, includeDeductedShipping = false) {
    const shippingAmount = includeDeductedShipping ? parseFloat(localStorage.getItem("shipping_amount") || 0) : 0;
    const originalAmount = (Number(baseAmountDollars) || 0) + (Number(shippingAmount) || 0);

    document.querySelectorAll(".total-discount-amount").forEach((el) => {
      el.textContent = showAmount && originalAmount > 0 ? this.formatMoney(originalAmount * 100) : "";
      el.classList.toggle("d-none", !(showAmount && originalAmount > 0));
    });
  }


  showHideReOrderBOX(have){

    const {
      promoOffer = "",
      contractId = "",
      orderNo = 0,
    } = JSON.parse(subscriptionContractId || "{}");

    let newContractId = contractId;

    if(!newContractId && state.email){
      newContractId = this.getContractIdFromCache(state.email);    
    }

    if(have){
      if(newContractId){        
        document.querySelector("#re-order").style.display = "none";
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "none";
        });
      }else if (userLoggedIn && !this.isExcluded_Global) {
        document.querySelector("#re-order").style.display = "flex";
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "block";
        });
      }else{
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "block";
        });
      }
    }else{ 
      if(userLoggedIn){
        if(newContractId){        
          document.querySelector("#re-order").style.display = "none";
          document.querySelectorAll(".discount-card").forEach(el => {
            el.style.display = "none";
          });
        }else if (!this.isExcluded_Global) {
          document.querySelector("#re-order").style.display = "none";
          document.querySelectorAll(".discount-card").forEach(el => {
            el.style.display = "block";
          });
        }
      }else{ 
        document.querySelector("#re-order").style.display = "none";
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "none";
        });
      }
    }

  }


  updateCartInfoFromLocal(cartCellId, reload = 0, welcomeApplied = false) {
      //this.formatMoney(1195); 
      const cart = this.getCartData();
      const cartCell = jQuery(cartCellId);
      let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
      const WELCOME25_APPLIED = localStorage.getItem("WELCOME25_APPLIED");
      jQuery(".upsell-desk-custom, .upsell-mob-custom").removeClass("display-none");
      jQuery(".main-cart-container").removeClass("w-100");
      if (typeof cartCellId !== "string" || !cartCell.length) {
        console.error("Invalid cartCellId provided or not found");
        return;
      }
      const { attributes = {}, items, total_price, item_count } = cart;
      const orderType = state_data.freq ? state_data.freq : "WeeklySubscription";
  
      cartCell.empty();
  
      const total_count = item_count;
      const mealsCount = this.countLunchAndDinnerMeals(items);
      const cart_show_count = item_count;
      let ISKETO = false;
      let ISNDIS = false;
      
      let hasAddressNew = !!(state_data?.address && String(state_data.address).trim() !== "");  
      
      const excludedTags = this.excludedTags_Global; 
      const isExcluded = this.isExcluded_Global;
      const isBluefitUser = this.isBluefit;
      const isPromoActive = this.additionalpromo && !isExcluded && (orderType === "OneTimePurchase" || orderType === "WeeklySubscription" || orderType === "FortnightlySubscription");   
  
      let totalPrice = 0;

  
      if (items.length > 0) {

        jQuery(".cart-item-loop, .subtotal-title-area").show();

        jQuery(".cart-tempty-title").hide();
  
        items.forEach(item => {
          const { price, compare_at_price, quantity, url, image, title, variant_id, product_type, id = variant_id, selling_plan = null, bf_true = false } = item;
          
          let priceHTML = "", comparePriceHTML = "";                    
          let actualPrice = price;

          /*if(this.additionalpromo && product_type === "LUNCH & DINNER"){
            actualPrice = PROMO_PROD_PRICE;
          }*/

          if (compare_at_price > actualPrice) {
            comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>`;
          }
  
          if (orderType === "OneTimePurchase") {

            const minOtp = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 8;
            const discountPercent = this.getApplicableDiscountPercent(mealsCount, typeof oneTimeOffers !== "undefined" ? oneTimeOffers : null, minOtp);
            let actualPrice2 = price;

            if(isBluefitUser) {
              console.log('price',price);
              actualPrice = BLUEFIT_PRICE;
            }
            console.log('isBluefitUser',isBluefitUser);
            console.log('actualPrice',actualPrice);

            if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
              ISNDIS = true;
              actualPrice2 = compare_at_price;
              const discountCents = Math.floor(actualPrice2 * customerData.ndisDiscountPercentage / 100);
              const discountedPriceCents = actualPrice2 - discountCents;
              totalPrice += discountedPriceCents * quantity / 100;
              comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = 1050;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = KETO_PRICE_T1;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = KETO_PRICE_T2;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3") && typeof customerData.ketoCustDiscountFixed === "number") {
              ISKETO = true;
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = KETO_PRICE_T3;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
             
            } else if (userLoggedIn && Array.isArray(customerData.tags) && isBluefitUser) {

                totalPrice += actualPrice * quantity / 100;                
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;

            } else if (product_type === "LUNCH & DINNER" && discountPercent > 0) {

              totalPrice += actualPrice * quantity / 100;

              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }

              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;

            } else {

              totalPrice += actualPrice * quantity / 100;
              
              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }

              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;

            }
          }

          if (orderType === "WeeklySubscription" || orderType === "FortnightlySubscription") {
            const minSubs = typeof MIN_SUBS_MEAL_LIMIT !== "undefined" ? MIN_SUBS_MEAL_LIMIT : 10;
            const subsDiscountPercent = this.getApplicableDiscountPercent(mealsCount, typeof promotionalOffers !== "undefined" ? promotionalOffers : null, minSubs);
            let actualPrice2 = price;

            if(isBluefitUser) {
              console.log('price',price);
              actualPrice = BLUEFIT_PRICE;
            }

            if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
              actualPrice2 = compare_at_price;
              const discountCents = Math.floor(actualPrice2 * customerData.ndisDiscountPercentage / 100);
              const discountedPriceCents = actualPrice2 - discountCents;
              totalPrice += discountedPriceCents * quantity / 100;
              comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
              if (product_type === "LUNCH & DINNER") {
                const subscriptionPrice2 = 1050;
                totalPrice += subscriptionPrice2 * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(subscriptionPrice2)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(compare_at_price || actualPrice)}</span>`;
              }
            } else if (product_type === "LUNCH & DINNER" && subsDiscountPercent > 0) {

              let discountCents = Math.floor(actualPrice * subsDiscountPercent / 100);              
              let discountedPriceCents = actualPrice - discountCents;
              totalPrice += actualPrice * quantity / 100;
                
              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }     

              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              
            } else {

              totalPrice += actualPrice * quantity / 100;

              if(this.additionalpromo && product_type === "LUNCH & DINNER"){
                comparePriceHTML = (compare_at_price > actualPrice) ? `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(compare_at_price)}</span>` : "";
              }
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
            }
          }

          const listItem = `
            <li class="cart-item d-flex align-items-stretch">                

              <div class="cart-image position-relative w-25 border rounded">
                <a href="${url}">
                  <img src="${image}" alt="${title}" class="img-fluid">
                </a>
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-orange px-2 py-1">${quantity}</span>
              </div>

              <div class="cart-title d-flex flex-column w-75">

                <div class="cart-top-area d-flex justify-content-between align-items-start">
                  <a class="cart_item_title" href="${url}">
                    ${title}
                  </a>

                  <div class="delete-item-cart">
                    <a class="remove_from_cart" href="javascript:void(0);" onclick="localCart.changeInToLocalCart(${variant_id}, 0)">
                      <i class="fa-solid fa-times fw-bolder"></i>
                    </a>
                  </div>
                </div>

                <div class="cart-pro-info d-flex align-items-center justify-content-between mt-auto">

                  <div class="cart-qty-price d-flex align-items-center gap-3">
                    <span class="quantity-${id} d-none">${quantity}</span>
                    <span class="price-box align-items-center d-flex gap-2">
                      ${comparePriceHTML}
                      ${priceHTML}
                    </span>
                  </div>

                  <div class="product-quantity-action text-end d-flex align-items-center">
                    <div class="product-quantity" data-variant="${id}">
                      <div class="cart-plus-minus">
                        <div class="dec qtybutton" data-action="-">
                          <i class="icon-minus fw-bolder"></i>
                        </div>

                        <input value="${quantity}" type="text" class="qtyinputcs" name="quantity" min="1" pattern="[0-9]*">

                        <span class="cusqtyspan quantity-${id}">${quantity}</span>

                        <div class="inc qtybutton" data-action="+">
                          <i class="icon-plus fw-bolder"></i>
                        </div>
                      </div>
                    </div>

                    <span class="cart-loading load-anim d-none">
                      <i class="ion-load-a"></i>
                    </span>
                  </div>

                </div>

              </div>
            </li>
          `;
          cartCell.append(listItem);
        });

      } else {

        jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").hide();
        jQuery(".cart-tempty-title").show();
        jQuery(".cart-item-title").hide();

        if (cartCell) {
          const li_empty = '<li><div class="cart-empty-title" ><i class="icon-handbag"></i><p class="text-center mb-4">You have no items in your cart</p><a href="/collections/fresh-ready-meals" class="btn btn-style3">Browse Menu</a></div></li>';
          cartCell.append(li_empty);
        }

      }

      if(window.innerWidth < 999){
        jQuery(".upsell-desk-custom, .upsell-mob-custom").addClass("display-none");
      }
  
      this.updateTotalDiscountAmount(0, false);
      const cartCounter = jQuery(".bigcounter");
      const cartcountitem = jQuery(".cart-count-item");  
      
      // console.log(totalPrice);
  
      //if (!(subscriptionContractId && userLoggedIn)) {
        cartCounter.html(cart_show_count).addClass("added-cart-event");
        cartcountitem.html(cart_show_count);
      //}
  
      setTimeout(() => cartCounter.removeClass("added-cart-event"), 2000);
      jQuery(".currency .active").trigger("click");
      // console.log({cart, totalPrice});

      //console.log('totalPrice',totalPrice);
      
      let url = new URL(window.location.href);
      let hasFlag = url.searchParams.has("open-mini-cart");
      
      if(hasFlag){
        this.hasFlag = true;
        if(state_data.postcode && state_data.suburb){
          listSuburbsBasedOnPostCode(state_data.postcode, state_data.suburb);
          applyShippingAmount();
        }
      }
      
      let shipping_amount_get = (localStorage.getItem("shipping_amount") || 0);
      let selected_Frequency_New = state_data?.freq || "OneTimePurchase";
      let shipping_aa = parseFloat(shipping_amount_get);
      let totalwithshipping = totalPrice;

      let isSubscription = ["WeeklySubscription", "FortnightlySubscription"].includes(selected_Frequency_New);
      if((shipping_aa > 0) && !ISNDIS && (state_data.address != '')){
        if(selected_Frequency_New === "OneTimePurchase" || (isSubscription && mealsCount < 10)){
          /*if(this.welcome25){
            totalwithshipping = totalwithshipping - 25;
          }*/
          totalwithshipping += shipping_aa;
        }
      }
      
      /*console.log('welcomeApplied', welcomeApplied);
      console.log('shipping_aa', shipping_aa);
      console.log('welcome25',this.welcome25);
      console.log('totalPrice--',totalPrice);
      console.log('totalwithshipping--',totalwithshipping);
      if(this.welcome25){
        totalPrice = totalPrice - 25;
      }*/

      this.generateOfferDOM(cart, totalPrice, totalwithshipping, welcomeApplied);

      if(Object.keys(state_data).length){
        state_data = state;
      }
      let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      
      const {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");


      let newContractId = contractId;

      if(!newContractId && state_data.email){
        newContractId = this.getContractIdFromCache(state_data.email);    
      }

      //let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
      //let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

      const finalflow = document.getElementById("finalflow");
      const borderTop = document.getElementById("border-topbg-white");
      const cartWrap = document.getElementById("cart-item-wrap");
      const continueBtn = document.querySelector("#continue_to_shipping");

      const hasStateData = Object.keys(state_data).length > 0;

      const hasDeliveryInfo =
        deliveryInfoNew.deliveryDate &&
        deliveryInfoNew.deliveryStart &&
        deliveryInfoNew.deliveryEnd &&
        state_data.address &&
        state_data.suburb &&
        state_data.state &&
        state_data.postcode;

      const showCartFlow = () => {
        finalflow.style.display = "none";
        borderTop.style.display = "block";
        cartWrap.style.display = "block";
        this.showHideReOrderBOX(1);
      };

      const showFinalFlow = () => {
        borderTop.style.display = "none";
        cartWrap.style.display = "none";
        finalflow.style.display = "block";
        this.showHideReOrderBOX(0);
      };

      // Default
      showCartFlow();

      if (!reload && (!hasStateData || !hasDeliveryInfo)) {
        console.log("phase", "1");
        showFinalFlow();

      } else if (!isLogin && !reload) {

        console.log("phase", "3");

        if (hasStateData && hasDeliveryInfo) {
          console.log("phase", "31");
          showCartFlow();
        } else {
          console.log("phase", "32");
          showFinalFlow();
        }

      } else if (!isLogin && reload) {
        console.log("phase", "4");
        showCartFlow();

      } else if (isLogin && reload) {
        console.log("phase", "5");
        showCartFlow();

      } else if (isLogin && !reload) {
        console.log("phase", "6");

        if (hasStateData && hasDeliveryInfo) {
          console.log("phase", "61");
          showCartFlow();
        } else {
          console.log("phase", "62");
          showFinalFlow();
        }
      }

      if (hasFlag) {
        console.log("phase", "64");

        document.querySelector(".cart-count")?.click();
        url.searchParams.delete("open-mini-cart");

        this.showHideReOrderBOX(1);

        if (state_data.postcode && state_data.suburb) {
          listSuburbsBasedOnPostCode(state_data.postcode, state_data.suburb);
        }

        console.log("isExcluded", isExcluded);
        console.log("newContractId", newContractId);
        console.log("isLogin", isLogin);        

        if (!isExcluded && !newContractId && isLogin) {

          console.log("phase", "65");
          console.log("deliveryInfoNew", deliveryInfoNew);
          console.log("state_data 65", state_data);
          
          document.querySelector("#pre_selected_data").style.display = "block";
          document.querySelector("#pre_selected_data_wrap").style.display = "block";

          if (hasDeliveryInfo) {

            console.log("phase", "651");
            this.showHideReOrderBOX(1);

          }else{

            document.getElementById("step2")?.classList.remove("hidden");
            console.log("phase", "652");
            this.showHideReOrderBOX(1);
            document.querySelector("#re-order").style.display = "none";
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });

          }

          this.updateTierDiscountCard();

          console.log('hasFlag1', hasFlag);

        } else if (newContractId && isLogin) {

          console.log("phase", "66");

          document.querySelector("#pre_selected_data").style.display = "none";
          document.querySelector("#pre_selected_data_wrap").style.display = "none";
          showCartFlow();
          this.showHideReOrderBOX(0);
          console.log('hasFlag2', hasFlag);

        }else if (isLogin){

          console.log("phase", "67");
          
          if(isExcluded){

            console.log("phase", "671");

            document.getElementById("step2")?.classList.remove("hidden"); 
            document.querySelector("#re-order").style.display = "none";
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });

          }else{
            
            document.querySelector("#pre_selected_data").style.display = "block";
            document.querySelector("#pre_selected_data_wrap").style.display = "block";

            if (hasDeliveryInfo) {

              console.log("phase", "672");

              document.querySelector("#re-order").style.display = "flex";
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "block";
              });

            }else{

              console.log("phase", "673");

              document.getElementById("step2")?.classList.remove("hidden");
              document.querySelector("#re-order").style.display = "none";
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "none";
              });
              
            }

          }
          console.log('hasFlag3', hasFlag);

        }

        //checkWELCOME25FromCart();
        
        window.history.replaceState({}, document.title, url.toString());
        

      } else {

        console.log("isExcluded1", isExcluded);
        console.log("newContractId1", newContractId);
        console.log("isLogin1", isLogin);
        console.log("hasDeliveryInfo", hasDeliveryInfo);

        console.log("phase", "68");

        if (!isExcluded && !newContractId && isLogin) {  

          console.log("phase", "69");
          
          document.querySelector("#pre_selected_data").style.display = "block";
          document.querySelector("#pre_selected_data_wrap").style.display = "block";        

          if (hasDeliveryInfo) {

            console.log("phase", "691");

            this.showHideReOrderBOX(1);

          }else{

            document.getElementById("step2")?.classList.remove("hidden");
            console.log("phase", "692");
            this.showHideReOrderBOX(1);
            document.querySelector("#re-order").style.display = "none";
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });
            
          }
          
          this.updateTierDiscountCard();
          console.log('hasFlagNon1');

        } else if (newContractId && isLogin) {

          console.log("phase", "70");
          document.querySelector("#pre_selected_data").style.display = "none";
          document.querySelector("#pre_selected_data_wrap").style.display = "none";
          showCartFlow();
          this.showHideReOrderBOX(0);
          console.log('hasFlagNon2');

        }else if (isLogin){

          console.log("phase", "71");
          
          if(isExcluded){

            document.getElementById("step2")?.classList.remove("hidden"); 
            document.querySelector("#re-order").style.display = "none";
            document.querySelectorAll(".discount-card").forEach(el => {
              el.style.display = "none";
            });

          }else{
            
            document.querySelector("#pre_selected_data").style.display = "block";
            document.querySelector("#pre_selected_data_wrap").style.display = "block";

            if (hasDeliveryInfo) {

              document.querySelector("#re-order").style.display = "flex";
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "block";
              });

            }else{

              document.getElementById("step2")?.classList.remove("hidden");
              document.querySelector("#re-order").style.display = "none";
              document.querySelectorAll(".discount-card").forEach(el => {
                el.style.display = "none";
              });
              
            }

          }

          console.log('hasFlagNon3');

        }else{

          console.log("phase", "72");
          let new_step = parseInt(state_data.step || 0, 10);

          if (Object.keys(state_data).length === 0 || (new_step < 2)) {   

            console.log("phase", "721");
            
            showFinalFlow();     

          }else{

            console.log("phase", "722");
          
            document.querySelector("#pre_selected_data").style.display = "block";
            document.querySelector("#pre_selected_data_wrap").style.display = "block";
            showCartFlow();

          }
        }
      }

      if (items.length > 0) {

        if(!isExcluded && (newContractId != '' || !newContractId)){
          this.updateTierDiscountCard();
        }
        this.checkAllVariantsOnLoad();

      }else{

        document.querySelector("#re-order").style.display = "none";
        document.querySelectorAll(".discount-card").forEach(el => {
          el.style.display = "none";
        });
      }

        continueBtn?.classList.remove("d-none");


  }


  getShippingAmount(appiled = true){
      const statenew = JSON.parse(localStorage.getItem("window_state") || "{}");
      const locaDelInit = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

      let shipping_amount = localStorage.getItem("shipping_amount") || 0;
      let selected_frequency = statenew?.freq;

      let amountEl = document.querySelector(".free-shipping-amount");
      let freeTextEl = document.querySelector(".free-shipping-text");
      let deliveryShippingEl = document.querySelector(".delivery-text-shippingamount");
      let mealsCountS = this.countLunchAndDinnerMeals(this.cart.items);

      if (!amountEl) return;

      const format = (cents) => this.formatMoney(cents);
      const defaultShippingCents = 1500; // $15.00 default
      const currentShippingCents = Math.round(parseFloat(shipping_amount || 0) * 100);

      const hasAddress = !!(statenew?.address && String(statenew.address).trim() !== "");      

      const setShippingText = (text) => {
        amountEl.textContent = text;
      };

      amountEl.classList.add("fw-bold");

      // ✅ Address blank হলে shipping Pending দেখাবে
      if (!hasAddress) {

        console.log('selected_frequency',selected_frequency);

        if(selected_frequency != "OneTimePurchase"){
          if(mealsCountS < 10){
            setShippingText("Pending");
            amountEl.classList.remove("free_amount");
          }else{      
            setShippingText("Free");
            amountEl.classList.add("free_amount");        
          }
        }else{          
          setShippingText("Pending");
          amountEl.classList.remove("free_amount");
        }

        amountEl.classList.remove("text-decoration-line-through");

        if (deliveryShippingEl) {
          deliveryShippingEl.textContent = "Pending";
        }

        if (freeTextEl) {
          freeTextEl.classList.add("d-none");
        }
        return;

      }else{  

        if (deliveryShippingEl) {
          deliveryShippingEl.textContent = format(currentShippingCents || defaultShippingCents);
        }

      }

      if (selected_frequency === "OneTimePurchase") {

        setShippingText(format(currentShippingCents || defaultShippingCents));

        amountEl.classList.remove("free_amount");
        amountEl.classList.remove("text-decoration-line-through");

        if (freeTextEl) {
          freeTextEl.classList.add("d-none");
        }

      }

      if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS")){

        setShippingText("$0.00");

        amountEl.classList.add("free_amount");
        amountEl.classList.remove("text-decoration-line-through");

        if (freeTextEl) {
          freeTextEl.textContent = format(currentShippingCents || defaultShippingCents);
          freeTextEl.classList.remove("d-none");
          freeTextEl.classList.add(
            "text-decoration-line-through",
            "text",
            "ms-1"
          );
          freeTextEl.classList.remove("text-grren", "text-uppercase");
        }

      } else if (selected_frequency === "OneTimePurchase") {

        setShippingText(format(currentShippingCents));
        amountEl.classList.remove("free_amount");
        amountEl.classList.remove("text-decoration-line-through");
        freeTextEl?.classList.add("d-none");

      } else if (
        selected_frequency === "WeeklySubscription" ||
        selected_frequency === "FortnightlySubscription"
      ) {
        const mealsCount = this.countLunchAndDinnerMeals(this.cart.items);

        if (mealsCount < 10) {
          setShippingText(format(currentShippingCents || defaultShippingCents));

          amountEl.classList.remove("text-decoration-line-through");
          amountEl.classList.remove("free_amount");
          freeTextEl?.classList.add("d-none");

        } else {
          setShippingText("$0.00");

          amountEl.classList.add("free_amount");
          amountEl.classList.remove("text-decoration-line-through");

          if (freeTextEl) {
            freeTextEl.textContent = format(currentShippingCents || defaultShippingCents);
            freeTextEl.classList.remove("d-none");
            freeTextEl.classList.add(
              "text-decoration-line-through",
              "text",
              "ms-1"
            );
            freeTextEl.classList.remove("text-grren", "text-uppercase");
          }
        }

      } else {
        setShippingText("$0.00");

        amountEl.classList.add("free_amount");
        amountEl.classList.remove("text-decoration-line-through");

        if (freeTextEl) {
          freeTextEl.textContent = format(defaultShippingCents);
          freeTextEl.classList.remove("d-none");
          freeTextEl.classList.add(
            "text-decoration-line-through",
            "text",
            "ms-1"
          );
          freeTextEl.classList.remove("text-grren", "text-uppercase");
        }
      }
  }
  
  getPromoForMeals(mealCount, total_price = 0.00) {
    let matchedPromo = false;
    let highestMin = -1;

    if (typeof promotionalOffers === "undefined") {
      return matchedPromo;
    }

    for (const [promoName, offer] of Object.entries(promotionalOffers)) {
      const { min, max } = offer.mealRange || {};

      const minMatched = typeof min === "number" && mealCount >= min;
      const maxMatched = max === null || typeof max === "undefined" || mealCount < max;

      if (minMatched && maxMatched && min > highestMin) {
        highestMin = min;
        matchedPromo = promoName;
      }
    }

    // If matched promo is promo0, return empty string
    if (matchedPromo === "promo0") {
      return false;
    }

    return matchedPromo;
  }

  createFormData(deliveryInfo, isSubscription) {
      //const deliveryDateISO = this.getSelectedDeliveryDateISO();
      const cartData = this.getCartData(),
          filteredCart = cartData.items.map(item => ({
              id: item.variant_id,
              properties: item.properties,
              quantity: item.quantity
          }));
      
      let { attributes = {}, items, total_price, item_count } = cartData;
      let order_type = attributes?.orderType?.type ?? "WeeklySubscription";   

      let applicableOffer = !1;
      if (!(userLoggedIn && customerData?.tags?.includes("NDIS") && typeof customerData.ndisDiscountPercentage == "number")) {
          const responseMeals = this.countLunchAndDinnerMeals(cartData.items);
          applicableOffer = this.getPromoForMeals(responseMeals);
          //console.log('responseMeals', responseMeals); 
          //console.log('applicableOffer1', applicableOffer);   
      }

      const formatTime = (timeStr) => {
        return timeStr && timeStr.length === 5 ? `${timeStr}:00` : timeStr;
      };

      //console.log('applicableOffer', applicableOffer);  
      //console.log('order_type', order_type);  

      const {
          deliveryDate,
          deliveryEnd,
          deliveryStart,
          packingDate
      } = JSON.parse(deliveryInfo || "{}"), deliveryAttributes = {
          DeliveryDate: deliveryDate || "",
          PackingDate: packingDate || "",
          DeliveryStart: formatTime(deliveryStart) || "",
          DeliveryEnd: formatTime(deliveryEnd) || "",
          AddressType: "residential",
          promotional: false, //((order_type === "WeeklySubscription") || (order_type === "FortnightlySubscription")) ? applicableOffer : false,
          orderType: isSubscription.type
      };
      return {
          items: filteredCart,
          attributes: deliveryAttributes
      }
  }

  applicableDiscount(cartData, orderTypeN) {

    const { attributes = {}, total_price, items, original_total_price } = cartData;
    
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
      orderTypeN = "OneTimePurchase";
    }else{
      orderTypeN = state.freq ? state.freq : (attributes?.orderType?.type || "WeeklySubscription");
    }
    console.log('orderTypeN',orderTypeN);
    if (orderTypeN === "OneTimePurchase") {
      //alert(11);
      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
          //alert(12);
          return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else{
          const mealsCount = this.countLunchAndDinnerMeals(items);
          const minOtp = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 8;
          let discount;
          if (mealsCount >= minOtp && typeof oneTimeOffers !== "undefined") {
            let highestMin = -1;
            Object.values(oneTimeOffers).forEach(offer => {
              const { min } = offer.mealRange || {};
              if (typeof min === 'number' && mealsCount >= min && min > highestMin) {
                highestMin = min;
                discount = offer.offerDiscount;
              }
            });
          }
        return discount || null;
      }
    } else if (orderTypeN === "WeeklySubscription" || orderTypeN === "FortnightlySubscription") {
      //alert(12);
      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
          //alert(0);
          return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(1);
          return null;
      } else {          
        const responseMeals = this.countLunchAndDinnerMeals(items);
        const applicableOffer = this.getPromoForMeals(responseMeals, total_price);
        console.log('applicableOffer',applicableOffer);
        if (applicableOffer && promotionalOffers[applicableOffer]) {
          return promotionalOffers[applicableOffer].offerDiscount;
        }
        return null;
      }
    }
    return null;
  }

  updateCartAttrFromLocal(attributes){
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    })
    .then(res => res.json())
    .then(data => {
      //console.log('Cart attributes updated:', data);
    })
    .catch(err => {
      console.error('Error updating cart attributes:', err);
    });
  }
  

  proceedToCheckout(requestPath) {  

    let threeHours = 4 * 60 * 60 * 1000;
    let loca_del_n = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    let window_state_NEW = JSON.parse(localStorage.getItem("window_state") || "{}");
    if (loca_del_n.timestamp && (Date.now() - loca_del_n.timestamp > threeHours)) {
      console.log("🕒 Delivery selection expired (3 hours). Clearing.");
      localStorage.setItem("deliveryInfo", JSON.stringify({}));
      loca_del_n = {};
      if (typeof state !== 'undefined') {      
        state.date = "";
        state.time = "";
        state.state = "";
        state.suburb = "";
        state.postcode = "";
        window_state_NEW = state;
        localStorage.setItem("window_state", JSON.stringify(window_state_NEW));
      }
    }

    const stateData = JSON.parse(localStorage.getItem("window_state") || "{}");
    const cartAttrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
    const orderType = stateData.freq || cartAttrs?.orderType?.type || "WeeklySubscription";
    /*if (!this.hasDeliveryAndAddressFilled(orderType)) {
      this.openMiniCartToDeliveryStep("Please enter your delivery address to continue.");
      return;
    }*/

    this.continueToShipping(requestPath);
  }

  async checkVariantAvailability(variantId) {
    try {
      const res = await fetch('/variants/' + variantId + '.js');

      if (!res.ok) {
        console.warn("❌ Variant not found:", variantId);
        return false;
      }

      const data = await res.json();

      console.log("🔍 Variant:", data.name);
      //console.log("Available:", data.available);
      //console.log("Inventory:", data.inventory_quantity);
      return data.available === true;

    } catch (err) {
      console.error("❌ Fetch error for variant:", variantId, err);
      return false;
    }
  }

  checkUnavailableCount() {
    const errorBox = document.querySelector(".show_error_checkout");

    // count remaining invalid items
    const remaining = document.querySelectorAll(".cart-item.have-variant-error").length;

    console.log("Remaining invalid items:", remaining);

    if (remaining === 0) {
      if (errorBox) {
        errorBox.style.display = "none";
        errorBox.innerHTML = "";
      }

      console.log("✅ All invalid items cleared → hide error box");
    }
  }
  
  async checkAllVariantsOnLoad(force = false) {
    const cartData = this.getCartData();
    const errorBox = document.querySelector(".show_error_checkout");

    // ✅ API Check: Only once a day
    const lastCheckDate = localStorage.getItem("last_availability_check");
    const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    if (!force && lastCheckDate === today) {
      console.log("✅ Availability check already performed today.");
      return true;
    }

    if (errorBox) errorBox.innerHTML = "";

    const uniqueItems = [];
    const seen = new Set();

    cartData.items.forEach(item => {
      if (!seen.has(item.variant_id)) {
        seen.add(item.variant_id);
        uniqueItems.push({
          id: item.variant_id,
          name: item.title
        });
      }
    });

    if (uniqueItems.length === 0) {
       localStorage.setItem("last_availability_check", today);
       return true;
    }

    const results = [];

    for (const item of uniqueItems) {
      const avail = await this.checkVariantAvailability(item.id);

      results.push({
        ...item,
        available: avail
      });
    }

    const unavailable = results.filter(r => !r.available);

    if (unavailable.length > 0) {
      // ✅ Automatically remove unavailable items from local cart
      let itemsRemoved = false;
      const removedNames = [];

      unavailable.forEach(u => {
        const initialLength = this.cart.items.length;
        // Remove ALL instances of this variant
        this.cart.items = this.cart.items.filter(item => item.variant_id !== u.id);
        
        if (this.cart.items.length < initialLength) {
          removedNames.push(u.name);
          itemsRemoved = true;
        }
      });

      if (itemsRemoved) {
        this._saveCart();
        // Mark as checked today so it doesn't re-trigger on the refresh call
        localStorage.setItem("last_availability_check", today);
        
        // Update the cart UI
        this.updateCartInfoFromLocal(".cart-item-loop");
      }

      if (errorBox && removedNames.length > 0) {
        errorBox.innerHTML = `
          <div class="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-2" role="alert">
            <div class="fs-5 text-danger">
              <i class="fa-solid fa-triangle-exclamation"></i>
            </div>
            <div class="flex-grow-1">
              <div class="small">
                The following items were removed because they are currently unavailable: <strong>${removedNames.join(", ")}</strong>.
              </div>
            </div>
          </div>
        `;

        errorBox.scrollIntoView({ behavior: "smooth", block: "center" });

        // ✅ Fade out after 15 seconds
        setTimeout(() => {
          jQuery(errorBox).fadeOut(1000, function() {
            jQuery(this).empty().show();
          });
        }, 15000);
      }

      console.warn("❌ Unavailable items removed:", unavailable);
      return false;
    }

    // ✅ Mark as checked today
    localStorage.setItem("last_availability_check", today);
    return true;
  }

  goToStep(step, message = "") {
    try {
      // open mini cart first
      document.querySelector(".cart-count")?.click();               
      document.querySelector("#re-order").style.display = "none";
      document.querySelector(".discount-card-minicart").style.display = "none";

      setTimeout(() => {
        const flow = document.getElementById("finalflow");
        if (flow) flow.style.display = "block";

        // hide other sections (same as your code)
        ["border-topbg-white", "cart-item-wrap", "cart-item-title"].forEach(id => {
          const el = document.getElementById(id);
          if (el) el.style.display = "none";
        });

        // update step
        if (window.state) {
          window.state.step = step;
        }

        if (typeof show === "function") {
          show(`#step${step}`);
        }

        // scroll
        flow?.scrollIntoView({ behavior: "smooth", block: "start" });

        // show error
        if (message) {
          console.warn("⚠️ Step Redirect:", message);

          if (step === 2) {
            const el = document.getElementById("address_12Text");
            const el_address_12 = document.getElementById("address_12");
            const el12 = document.getElementById("address_text_12");
            if (el) {
              el.textContent = message;
              el.style.display = "block";
              el.classList.add("error");

              // ✅ Fade out after 15 seconds
              setTimeout(() => {
                jQuery(el).fadeOut(1000, function() {
                  jQuery(this).empty().hide().removeClass("error");
                });
              }, 15000);
            }
            if (el12) {
              el12.style.display = "none";
            }
            if (el_address_12) {
              el_address_12.value = "";
            }
          }
        }

      }, 100);

    } catch (err) {
      console.error("Step navigation error:", err);
    }
  }
  
  validateBeforeCheckout() {

      const state = JSON.parse(localStorage.getItem("window_state") || "{}");
      const delivery = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      const cartData = this.getCartData();

      /* -------------------------
      STEP 3 FIRST (HIGH PRIORITY)
      ------------------------- */

      // ❌ Frequency missing
      if (!state.freq) {
        return {
          valid: false,
          step: 3,
          message: "Please select subscription type"
        };
      }

      // ❌ Shipping missing
      const shipping = localStorage.getItem("shipping_amount");
      if (!shipping || shipping === "" || shipping === "null") {

        return {
          valid: false,
          step: 3,
          message: "Shipping not calculated"
        };
      }

      /* -------------------------
      STEP 2 (DELIVERY + ADDRESS)
      ------------------------- */

      if (!delivery.deliveryDate || !delivery.deliveryStart || !delivery.deliveryEnd) {

        document.querySelector(".windowTime")?.classList.add("hidden");
        document.querySelector(".dispatchDate")?.classList.add("hidden");
        document.querySelector("#toPlan")?.classList.add("hidden");
        document.querySelector(".windowDate")?.classList.add("hidden");

        return {
          valid: false,
          step: 2,
          message: "Please enter delivery address after then select delivery date and time slot."
        };
      }

      if (!state.address || !state.suburb || !state.state || !state.postcode) {

          
        document.querySelector(".windowTime")?.classList.add("hidden");
        document.querySelector(".dispatchDate")?.classList.add("hidden");
        document.querySelector("#toPlan")?.classList.add("hidden");
        document.querySelector(".windowDate")?.classList.add("hidden");

        return {
          valid: false,
          step: 2,
          message: "Please enter delivery address after then select delivery date and time slot."
        };
      }

      return { valid: true };
    }

  async continueToShipping(requestPath) { 
    
    //document.getElementById("loading-screen").style.display = "block";
    const button = document.getElementById("continue_to_shipping");
    button?.classList.add("loading");

    const validation = await this.validateBeforeCheckout();

    if (!validation.valid) {

      console.log("❌ Validation:", validation);

      this.goToStep(validation.step, validation.message);

      return;
    }

    /* 🔥 CALL HERE */
    const isValidVariants = await this.checkAllVariantsOnLoad(true);

    if (!isValidVariants) {
      button?.classList.remove("loading");      
      //document.getElementById("loading-screen").style.display = "block";    
      return; // ⛔ STOP checkout
    }

    try {        
      // STEP 1: Clear Shopify cart first        
      fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
      
    .then(res => res.json())
    .then(data => {
        
        document.getElementById("loading-screen").style.display = "block";    
        const cartData = this.getCartData(); 
        let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
        const { attributes, total_price, original_total_price } = cartData;
        const isNDIS = userLoggedIn && customerData?.tags?.includes("NDIS") && typeof customerData?.ndisDiscountPercentage === "number";
        const isKeto = userLoggedIn && customerData?.tags?.includes("keto_customers") && typeof customerData?.ketoCustDiscountFixed === "number";
        const T1 = userLoggedIn && customerData?.tags?.includes("T1") && typeof customerData?.ketoCustDiscountFixed === "number";
        const T2 = userLoggedIn && customerData?.tags?.includes("T2") && typeof customerData?.ketoCustDiscountFixed === "number";
        const T3 = userLoggedIn && customerData?.tags?.includes("T3") && typeof customerData?.ketoCustDiscountFixed === "number";
        //const conditn = userLoggedIn && customerData?.tags?.includes("conditn") && typeof customerData?.ketoCustDiscountFixed === "number";
        const bluefit = this.isBluefit;
        const orderType = isKeto ? "OneTimePurchase" : (state_data.freq ? state_data.freq : (attributes?.orderType?.type || "WeeklySubscription"));
        let discountCode = '';
        if(!bluefit){
          discountCode = this.applicableDiscount(cartData, orderType);    
        }

        const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
        const mealStyle = selectedMeal.value;

        const sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
        const {
          promoOffer = "",
          contractId = "",
          orderNo = 0,
        } = JSON.parse(subscriptionContractId || "{}");        

        let newContractId = contractId;

        if(!newContractId){
          newContractId = this.getContractIdFromCache(state.email);    
        }

        //const frequencySelect = document.getElementById("order-frequency");
        const selectedFrequency = state_data?.freq || (frequencySelect?.value || "OneTimePurchase");

        //this.applicableDiscount(cartData, orderType);
        //return false; 

        const deliveryInfo = localStorage.getItem("deliveryInfo");
  
        // Create form data from localCart
        var formData = localCart.createFormData(deliveryInfo, {
          selling: !isKeto,
          type: isKeto ? "OneTimePurchase" : selectedFrequency
        });
  
        const cartItems = formData.items;
        const deliveryDateValue = attributes?.deliverydate ?? attributes?.DeliveryDate ?? formData.attributes?.DeliveryDate ?? formData.attributes?.deliverydate ?? "";
        const items = cartItems.map(item => {
          const cartItem = item;    
          if (selectedFrequency === "WeeklySubscription") {
            cartItem.selling_plan = SELLING_PLAN_S;   // Weekly plan ID
          } else if (selectedFrequency === "FortnightlySubscription") {
            cartItem.selling_plan = SELLING_PLAN_FS; // Fortnightly plan ID
          }

          cartItem.properties = {
            ...(cartItem.properties || {}),
            DeliveryDate: deliveryDateValue
            //selectedFrequency: selectedFrequency
          };
          return cartItem;
        });

        //console.log(items); return;   

        //var all_attributes = formData.attributes;
        
        const mealsCount = this.countLunchAndDinnerMeals(localCart.getCartData().items);     
        // console.log({formData});
        // return false;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(data => {
            // STEP 4: Build redirect URL
            const addressParams = this.validatedAddress();
            const queryString = Object.entries(addressParams)
              .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
              .join("&");
            const checkoutUrl = `${shopUrl}/checkout?${queryString}`;
            let redirectUrl = discountCode ? `${checkoutUrl}&discount=${discountCode}` : checkoutUrl;

            //console.log(all_attributes); return;
            //this.updateCartAttrFromLocal(all_attributes);
          
            console.log('discountCode==',discountCode);
            //alert(discountCode);
            //console.log(orderType);
          
            // STEP 5: Apply cart validation
            if (orderType === "OneTimePurchase") {    
              // const minOtpMeals = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 8;
              // if (mealsCount < minOtpMeals) {
              //   document.getElementById("loading-screen").style.display = "none";
              //   return this._showMinResponse(`Min Order. ${minOtpMeals} meals`, button);
              // }
              if(isKeto || isNDIS || T1 || T2 || T3){
                //isNDIS users                             
                let acctual_total_price = original_total_price - ((original_total_price / 100) * customerData.ndisDiscountPercentage);
                acctual_total_price = acctual_total_price.toFixed(2);
                if (isNDIS && (acctual_total_price < MIN_NDIS_OTP_CART_AMOUNT)) { 
                  // console.log(`You need minimum $${MIN_NDIS_OTP_CART_AMOUNT} to checkout`);
                  document.getElementById("loading-screen").style.display = "none";
                  return this._showMinResponse(`Minimum $${MIN_NDIS_OTP_CART_AMOUNT} to checkout`, button);
                }  
                //isKeto users
                acctual_total_price = original_total_price - ((original_total_price / 100) * customerData.ketoCustDiscountFixed);
                acctual_total_price = acctual_total_price.toFixed(2);
                if (isKeto &&  (acctual_total_price < MIN_OTP_CART_AMOUNT)) {
                  
                  // console.log(`You need minimum $${MIN_OTP_CART_AMOUNT} to checkout`);
                  document.getElementById("loading-screen").style.display = "none";
                  return this._showMinResponse(`Minimum $${MIN_OTP_CART_AMOUNT} to checkout`, button);
                }
              }

              //Nornal User
              if (!isKeto && !isNDIS && total_price / 100 < MIN_OTP_CART_AMOUNT){
                // console.log(`You need minimum $${MIN_OTP_CART_AMOUNT} to checkout`);
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Minimum $${MIN_OTP_CART_AMOUNT} to checkout`, button); 
              }
              
              if (requestPath === "mini-cart") {
                window.location.href = redirectUrl; //isKeto ? redirectUrl : `${shopUrl}/pages/extras`;
              } else {
                window.location.href = redirectUrl;
              }
              
            } else if (orderType === "WeeklySubscription" || orderType === "FortnightlySubscription") {
              
              if (isNDIS && ((total_price / 100) < MIN_NDIS_SUBS_CART_AMOUNT)){
                // console.log(`You need minimum $${MIN_NDIS_SUBS_CART_AMOUNT} to subscribe`);
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Min Order. $${MIN_NDIS_SUBS_CART_AMOUNT} meals`, button);
              }
              if (mealsCount < MIN_SUBS_MEAL_LIMIT){
                // console.log(`You need minimum ${MIN_SUBS_MEAL_LIMIT} meals to subscribe`);

                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`, button);

              } 
               // console.log(redirectUrl);
              window.location.href = redirectUrl;

            }
        });
    });
      //document.getElementById("loading-screen").style.display = "none";
    } catch (error) {
      console.error("Checkout Error:", error);
      document.getElementById("loading-screen").style.display = "none";
    } finally {
      //button?.classList.remove("loading");
      document.getElementById("loading-screen").style.display = "none";
    }
  }
  _showMinResponse(message, button) {
      if (message) {
          const responseEl = document.getElementById("min-response");
          responseEl && (responseEl.innerHTML = message), button?.classList.remove("loading")
      }
  }
  updateSubscription() {
      const cart = this.getCartData();

      const { total_price = 0, items = [] } = cart || {};
      
      const cartAmountInDollars = total_price / 100;
      
      const mealsCount = this.countLunchAndDinnerMeals(items);

      const { promoOffer = "", contractId = "", orderNo } = JSON.parse(subscriptionContractId || "{}");
      
      const normalizedPromoOffer = typeof promoOffer === "string" ? promoOffer.trim() : null;
      const isPromoOfferValid =
        normalizedPromoOffer &&
        normalizedPromoOffer !== "false" &&
        Object.prototype.hasOwnProperty.call(promotionalOffers, normalizedPromoOffer);

      document.querySelector(".minimum-text-info")?.classList.remove("d-none");
      if (isPromoOfferValid && (orderNo > 0 && orderNo < 5)) {
        const result = promotionalOffers[normalizedPromoOffer];
        if (result) {
          const { min = 0, max } = result.mealRange || {};
          const minRequired = max === null ? min : max;
          if (mealsCount < minRequired) {
            document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                  el.textContent = `Min Order. ${minRequired} meals`;                    
            });
            return;
          } else {  
            document.querySelector(".minimum-text-info")?.classList.add("d-none");
          }
        }
      } else if (mealsCount < MIN_SUBS_MEAL_LIMIT) { 
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;                    
        });
        return;
      } else {
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      }
  
      // Contract ID check
      if (!contractId) {
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Something went wrong while subscription update. Please contact our support team.`;                    
        });
        return;
      }else{
        let preWrapNew = document.querySelector("#pre_selected_data_wrap");
        preWrapNew?.classList.add("hidden");
      } 

      const localItems = localCart.getCartData().items || [];
      const formData = {
        items: localItems.map(item => ({
          id: item.variant_id,
          quantity: item.quantity         
        }))
      };
      
      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      })
      .then(() => {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
      })
      .then(() => {
        // console.log({ localItems, formData });
        // alert("Cart synced successfully.");
        localStorage.setItem("proxy-contract-id", contractId);
        localStorage.removeItem("contractInfo");
        localStorage.removeItem("sub_cart_added");
        window.location.href = `/apps/account/contract/${contractId}/subscription-callback`;
      })
      .catch(err => {
        console.error("❌ Cart sync failed:", err);
      });
    
  }

  updateSubscriptionLocal() {

      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");

      let cart = this.getCartData();

      let { total_price = 0, items = [] } = cart || {};
      
      let cartAmountInDollars = total_price / 100;
      
      let mealsCount = this.countLunchAndDinnerMeals(items);

      let { promoOffer = "", contractId = "", orderNo } = JSON.parse(subscriptionContractId || "{}");

      document.querySelector(".minimum-text-info")?.classList.remove("d-none");

      document.getElementById("loading-screen").style.display = "block";

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);
        console.log('newContractId1',newContractId);          
      }

      if (mealsCount < MIN_SUBS_MEAL_LIMIT) { 
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;                    
        });
        return;
      } else {
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      }
  
      // Contract ID check
      if (!newContractId) {
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Something went wrong while subscription update. Please contact our support team.`;                    
        });
        return;
      }else{
        let preWrapNew = document.querySelector("#pre_selected_data_wrap");
        preWrapNew?.classList.add("hidden");
      } 

      const localItems = localCart.getCartData().items || [];

      const formData = {
        items: localItems.map(item => {

          let payload = {
            id: item.variant_id,
            quantity: item.qty || item.quantity
          };

          // ✅ add selling_plan if exists OR fallback
          if (item.selling_plan) {
            payload.selling_plan = item.selling_plan;
          } else {
            // fallback based on frequency
            if (item.properties?.selectedFrequency === "WeeklySubscription") {
              payload.selling_plan = SELLING_PLAN_S;
            } else if (item.properties?.selectedFrequency === "FortnightlySubscription") {
              payload.selling_plan = SELLING_PLAN_FS;
            }
          }

          // ✅ add properties (merge safely)
          payload.properties = {
            ...(item.properties || {}),
          };
          return payload;
        })
      };
      
      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      })
      .then(() => {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
      })
      .then(() => {
        // console.log({ localItems, formData });
        // alert("Cart synced successfully.");
        localStorage.setItem("proxy-contract-id", newContractId);
        localStorage.removeItem("contractInfo");
        localStorage.removeItem("sub_cart_added");
        //document.getElementById("loading-screen").style.display = "block";
        window.location.href = `/apps/account/contract/${newContractId}/subscription-callback`;
      })
      .catch(err => {
        console.error("❌ Cart sync failed:", err);
      });
    
  }

  displayCartTotal() {
      this.updateCartInfoFromLocal(".cart-item-loop");
  }
  getOrdinalSuffix(number) {
      const lastDigit = number % 10,
          lastTwoDigits = number % 100;
      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${number}th`;
      switch (lastDigit) {
          case 1:
              return `${number}st`;
          case 2:
              return `${number}nd`;
          case 3:
              return `${number}rd`;
          default:
              return `${number}th`
      }
  }

  subscriptionUpdateOffers(cart, totalPrice = null, getContractIdFromCache = null) { //alert('ss');
      
      let button = document.getElementById("continue_to_shipping");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
    
      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
      let {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");         

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);    
      }

      $(".guest-order").remove();
      document.querySelectorAll(".frequency-selector").forEach(el => el.remove());
      
      $(".update-subscription-btn").addClass("active");
      const mealsCount = this.countLunchAndDinnerMeals(cart.items);
      const cartAmountInDollars = totalPrice;
      
      const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
      const mealStyle = selectedMeal.value;

      //console.log('totalPrice', totalPrice);
    
      if (promoOffer && orderNo < 5) {
        
        const result = promotionalOffers[promoOffer] || null;
        if (result) {
            const { min = 0, max } = result.mealRange || {};
            const minRequired = max === null ? min : max;
            if (mealsCount < minRequired) {
                document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                    el.textContent = `Min Order. ${minRequired} meals`;
                });
                document.querySelector(".minimum-text-info")?.classList.remove("d-none");
            }else{
              document.querySelector(".minimum-text-info")?.classList.add("d-none");
            }
          const offerList = document.querySelector(".offer-bar-footer .offer-list");
          offerList.innerHTML = "";
          const cartCounter = jQuery(".bigcounter");
          cartCounter.html(cart.item_count).addClass("added-cart-event"); 
          if (typeof result.discounts === "number") {
            const discountContentDiv = document.createElement("div");
            discountContentDiv.classList.add("text-center","position-relative","custom-offerd-clc");
            const iconElement = document.createElement("i");
            iconElement.classList.add("icon-basket-loaded","h2","color-orange","d-block","mb-2","mt-3");
            const discountDiv = document.createElement("div");
            discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
            discountDiv.textContent = `${result.discounts}% off`;
            discountContentDiv.appendChild(iconElement);
            discountContentDiv.appendChild(discountDiv);
            offerList?.appendChild(discountContentDiv);
          } else if (Array.isArray(result.discounts)) {
            result.discounts.forEach((discount, index) => {
              const discountContentDiv = document.createElement("div");
              discountContentDiv.classList.add("text-center","position-relative","custom-offerd-clc");
              const badgeSpan = document.createElement("span");
              badgeSpan.classList.add("badge", (index >= orderNo) ? "bg-secondary" : "bg-orange", "d-block","mb-2","position-absolute","right-0","small");
              badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
              const iconElement = document.createElement("i");
              iconElement.classList.add("icon-basket-loaded","h2", (index >= orderNo) ? "text-secondary" : "color-orange", "d-block","mb-2","mt-3");
              const discountDiv = document.createElement("div");
              discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
              discountDiv.textContent = `${this.formatMoney(discount * 100)} off`;
              const dashDiv = document.createElement("div");
              dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
              discountContentDiv.appendChild(badgeSpan);
              discountContentDiv.appendChild(iconElement);
              discountContentDiv.appendChild(discountDiv);
              offerList?.appendChild(discountContentDiv);
              offerList?.appendChild(dashDiv);
            });
          }
        }
      }else if(mealsCount < MIN_SUBS_MEAL_LIMIT ) {

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        
      }else if (!newContractId && userLoggedIn && !mealStyle) { 

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Please select choose your goal`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        document.getElementById("continue_to_shipping").innerText = "Please select choose your goal";

      }else{
        
        document.querySelector(".minimum-text-info")?.classList.add("d-none");

      }

        document.querySelectorAll(".sub-total-amount, .total-price-amount").forEach((el) => {
          el.textContent = this.formatMoney(cartAmountInDollars * 100);
        });
  }

  renderQuantitySelector(cart) {
      const productElements = document.querySelectorAll(".product-all"),
          items = cart.items;
      productElements.forEach(productElement => {
          const dataVariant = productElement.dataset.productId,
              quantitySelector = productElement.querySelector(".quantity-selector"),
              addToCartSelector = productElement.querySelector(".add-cart-button"),
              matchedItem = items.find(item => item.product_id === Number(dataVariant));
          if (matchedItem) {
              const quantity = matchedItem.quantity,
                  variantId = matchedItem.variant_id,
                  quantityText = productElement.querySelector(`.quantity-${variantId}`),
                  quantityInput = productElement.querySelector("input.qtyinputcs");
              quantityText && (quantityText.textContent = quantity), quantityInput && (quantityInput.value = quantity), quantitySelector && quantitySelector.classList.remove("d-none"), addToCartSelector && addToCartSelector.classList.add("d-none")
          } else addToCartSelector && addToCartSelector.classList.remove("d-none"), quantitySelector && quantitySelector.classList.add("d-none")
      })
  }

  backToSetDelivery(){
    if(isLogin){
      document.getElementById("border-topbg-white").style.display = "none";
      document.getElementById("cart-item-wrap").style.display = "none";
      document.getElementById("cart-item-title").style.display = "none";
      document.getElementById("finalflow").style.display = "block"; 
      document.getElementById("step1").classList.add('hidden');
      document.getElementById("step2").classList.remove('hidden');
    }else{
      document.getElementById("border-topbg-white").style.display = "none";
      document.getElementById("cart-item-wrap").style.display = "none";
      document.getElementById("cart-item-title").style.display = "none";
      document.getElementById("finalflow").style.display = "block";
    }
  }

  loadCartData(btnADD=null) {
    this.overwriteFromRemoteCart();
    return this.getCartData();
  }
  
  
  generateOfferDOM(cart, totalPrice, totalwithshipping, welcomeApplied = false) {
      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
      const cartData = cart;
      const orderType = sdata_new?.freq ? sdata_new?.freq : (cartData.attributes?.orderType?.type || "WeeklySubscription");
      //console.log(orderType+'====');
      let cartDataNew;
      this.renderQuantitySelector(cartData);

      let {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);    
      }

      console.log('newContractId-DOM',newContractId);
      console.log('subscriptionContractId-DOM',subscriptionContractId);
  
      if (newContractId && userLoggedIn) {  
          const { total_price = 0, items = [] } = cart;
          this.subscriptionUpdateOffers(cart, totalPrice);
      } else {
          //console.log('Applying standard offers');
          document.querySelector(".menu-banner")?.classList.remove("d-none");
          $(".subtotal-title-area li:first-child").show();
          $(".subsciption-update").remove();
          $(".create-order-btn").addClass("active");
          localStorage.removeItem("contractInfo");
  
          // NDIS customer check
          if (
              userLoggedIn &&
              Array.isArray(customerData.tags) &&
              customerData.tags.includes("NDIS") &&
              typeof customerData.ndisDiscountPercentage === "number"
          ) {
              if (orderType === "OneTimePurchase") {
                  //console.log(cartData);
                  //console.log(totalPrice);
                  this.NDISoneTimePurchaseOffers(cartData, totalPrice, totalwithshipping);
              } else if (["WeeklySubscription", "FortnightlySubscription"].includes(orderType)) {
                  this.NDISsubscriptionOffers(cartData, totalPrice, totalwithshipping);
              }
          }
  
          // Keto customer check
          else if (
              userLoggedIn &&
              Array.isArray(customerData.tags) &&
              ((customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") || customerData.tags.includes("T1") || customerData.tags.includes("T2")  || customerData.tags.includes("T3") || this.isBluefit)
              
          ) {
              //console.log(totalPrice);
              this.KetoOneTimePurchaseOffers(cartData, totalPrice, totalwithshipping);
          }
  
          // Regular offers
          else {
              if (orderType === "OneTimePurchase") {
                  this.oneTimePurchaseOffers(cartData, totalPrice, totalwithshipping, welcomeApplied);
              } else if (["WeeklySubscription", "FortnightlySubscription"].includes(orderType)) {
                  this.subscriptionOffers(cartData, totalPrice, totalwithshipping);
              }
          }
      }

      document.getElementById("mini-cart").style.display = "block";
  }

    // ----------------------------------------
  // Show discount code row (REUSABLE)
  // ----------------------------------------
  showDiscountCodeRow({
    code,
    amount,
    orderTypeHave,
    container = ".discount-section",
    currency = "AUD",
  }) {
    if (!code) return;

    amount = Math.abs(amount);

    const discountSectionNEW = document.querySelector(container);
    if (!discountSectionNEW) return;

    let extraRow = document.querySelector(".welcome25-extra-row");

    if (!extraRow) {
      extraRow = document.createElement("div");
      extraRow.className =
        "welcome25-extra-row d-flex justify-content-between mt-1 small";

      // insert right after discount section
      discountSectionNEW.insertAdjacentElement("afterend", extraRow);
    }

    const formatted = Number(amount).toLocaleString("en-AU", {
      style: "currency",
      currency,
    });

    extraRow.innerHTML = `
      <label class="fs-12">Discount code (${code})</label>
      <span class="badge rounded-pill text-green-discount fw-bold discount-amount">
        -${formatted}
      </span>
    `;

    // Optional visual emphasis
    //discountSectionNEW.classList.add("strick_through");
    //document.querySelector(".offer-list-section")?.classList.add("shadow_row");
    discountSectionNEW?.classList.add("d-none");
  }


  getActivePromoOfferAppiled(mealsCount) {
    for (const [promo, offer] of Object.entries(promotionalOffers)) {
      const { min, max } = offer.mealRange || {};
      if (mealsCount >= min && mealsCount < max) {
        return { promo, offer };
      }
    }
    return null;
  }


  oneTimePurchaseOffers({
      original_total_price,
      items
  }, totalPrice, totalwithshipping, welcomeApplied) {

      let button = document.getElementById("continue_to_shipping");
      let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");
      const offerLists = document.querySelectorAll(".offer-list");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".per-serving-section")?.classList.add("d-none");
      
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".free-shipping-text")?.classList.add("d-none");
      document.querySelector(".minicart-msg-section")?.classList.add("d-none");
      document.querySelector(".offer-list-section ")?.classList.add("d-none");  
      
      const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
      const mealStyle = selectedMeal.value;

      let {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");

      let newContractId = contractId;

      if(!newContractId){
        newContractId = this.getContractIdFromCache(sdata_new.email);    
      }
      
      
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerLists) {
        //console.error('Element with id "offer-list" not found');
        //return;
      }
      const cartAmountInDollars = original_total_price / 100;
      const mealsCount = this.countLunchAndDinnerMeals(items);
      const minOtpMeals = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 8;
       if (cartAmountInDollars < MIN_OTP_CART_AMOUNT) {
         if (primaryButton) {
            primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
            primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
            primaryButton.innerHTML = `Add ${this.formatMoney((MIN_OTP_CART_AMOUNT - cartAmountInDollars) * 100)} to reach the order minimum`;
         }    
        document.querySelector(".minimum-text-info")?.classList.add("d-none");

        // } else if (mealsCount < minOtpMeals) {
        //   if (primaryButton) {
        //       primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
        //       primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        //       primaryButton.innerHTML = `Add ${minOtpMeals - mealsCount} more meals to your cart`;
        //   }
        //   document.querySelectorAll(".total-minimum-limit").forEach((el) => {
        //         el.textContent = `Min Order. ${minOtpMeals} meals`;
        //   });
        //   document.querySelector(".minimum-text-info")?.classList.remove("d-none");

      }else if (!newContractId && userLoggedIn && !mealStyle) { 

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Please select choose your goal`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");

      } else {
         if (primaryButton) {
            const deliveryDate = getCookie("expecting-delivery");
            //if (deliveryDate !== null) {
                primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
                primaryButton.classList.add("bg-orange","border-orange");
                primaryButton.innerHTML = 'Checkout Now';
            /*} else {
                primaryButton.removeAttribute("onclick");
                primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
                primaryButton.classList.add("checkPostalBtn2");
                primaryButton.innerHTML = 'Select Delivery Date and Checkout';
            }*/
         }
      }
      
      let notificationMessage = "Save up to 15% on Meals";
      let activeOffer=null;
      const basePrice = cartAmountInDollars.toFixed(2);
     
      offerLists.forEach((list) => (list.innerHTML = ""));
      if (offerListDetails) {
        offerListDetails.innerHTML = "";
      }
      let bestOffer = false;
      let totalDiscount = 0;
      let prevPromo=null;
      if (typeof oneTimeOffers !== "undefined") {
      Object.entries(oneTimeOffers).forEach(([promo, offer]) => {
        const { min, max } = offer.mealRange;
        totalDiscount = offer.discounts;
        const li = document.createElement("li");
        const isBestOffer = max === null ? mealsCount >= min : mealsCount >= max;
        li.classList.add("me-2","d-flex","align-items-center","rounded-pill", isBestOffer ? "bg-gradient-success" : "bg-off-grey");
        bestOffer = isBestOffer;
        if (mealsCount >= min && (max === null || mealsCount < max)) {
          notificationMessage= `${notificationMessage} <br><span class="small text-muted fs-12">${offer.notify}</span>`;
          const maxRange = max === null ? Math.max(mealsCount, min) : max;
          const widthPercentage = maxRange > 0 ? Math.min((mealsCount / maxRange) * 100, 100) : 100;
    
          const progressDiv = document.createElement("div");
          progressDiv.classList.add("d-flex","align-items-center","justify-end","rounded-pill","bg-gradient-success-secondary");
          progressDiv.style.transition = "width 1s";
          progressDiv.style.minWidth = "max-content";
          progressDiv.style.zIndex = "1";
          progressDiv.style.width = `${widthPercentage}%`;
    
          const innerDiv = document.createElement("div");
          innerDiv.classList.add("d-flex","align-items-center","justify-center","rounded-pill","bg-white","color-green","border-green","px-2","dynamic-margin","py-sm-0","py-1");
          innerDiv.textContent = `${mealsCount}/${max === null ? "17+" : maxRange}`;
    
          progressDiv.appendChild(innerDiv);
          li.style.width = "100%";
          li.classList.add("position-relative", "bg-off-grey");
          li.appendChild(progressDiv);
    
          const span = document.createElement("span");
          span.classList.add("position-absolute","right-0","text-dark","px-1","py-sm-0","py-1");
          span.textContent = `${totalDiscount}%OFF`;
          li.appendChild(span);
         
          if (prevPromo && typeof prevPromo.discounts === "number") {
            activeOffer = prevPromo;
          } else {
            const saveSpan = document.createElement("span");
            saveSpan.classList.add("fw-bold", "text-black", "py-2");
            saveSpan.textContent = "Save up to 15% on Meals";
            offerListDetails?.appendChild(saveSpan);
          }
        } else {
          const span = document.createElement("span");
          span.classList.add("rounded-pill","top-0","right-0","text-dark","p-1","text-white","text-center");
          span.textContent = `${totalDiscount}%${!isBestOffer ? 'OFF' : ''}`;
          li.appendChild(span);
        }
        prevPromo = offer;
        offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
      });
      }

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");

      //console.log(localStorage.getItem("WELCOME25_APPLIED"));

      if (bestOffer) {

        offerLists.forEach((list) => (list.innerHTML = "")); // Clear the list before appending the best offer
        const li = document.createElement("li");
        li.classList.add("me-2","d-flex","align-items-center","rounded-pill","bg-gradient-success");
        li.style.width = "100%";
        const span = document.createElement("span");
        span.classList.add("px-2","py-1","rounded-pill","top-0","right-0","text-dark","p-1","text-white","text-center");
        span.textContent = "You're saving 15% on Meals";
        li.appendChild(span);
        activeOffer = typeof oneTimeOffers !== "undefined" ? oneTimeOffers.promo3 : null;
        offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
      }
      document.querySelector(".offer-details-bar")?.classList.remove("d-none");
    
      document.querySelectorAll(".notification-message-mini-cart").forEach((el) => {
        el.innerHTML = notificationMessage;  // Use textContent if it's plain text
      });
      document.querySelector(".sub-total-section")?.classList.remove("d-none");
      document.querySelector(".sub-total-amount").textContent = this.formatMoney(totalPrice * 100);

      const minOtpN = typeof MIN_ONE_TIME_MEALS !== "undefined" ? MIN_ONE_TIME_MEALS : 10;  
      const totalDiscountPercent = this.getApplicableDiscountPercent(mealsCount, typeof oneTimeOffers !== "undefined" ? oneTimeOffers : null, minOtpN);

      let lunchdinnerItems = this.cart.items.filter(item => item.product_type === "LUNCH & DINNER");
      
      let offApplied = 0;
      lunchdinnerItems.forEach(item => {
        let itemPrice = item.price;

        if (this.additionalpromo && typeof PROMO_PROD_PRICE !== 'undefined') {
          itemPrice = PROMO_PROD_PRICE;
        }

        let itemDiscount = (itemPrice / 100) * (totalDiscountPercent / 100);

        // floor to 2 decimal places
        let finalDiscount = Math.floor(itemDiscount * 100) / 100;

        offApplied += finalDiscount * item.qty;

      });
      offApplied = offApplied.toFixed(2);
      
      if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit){
        offApplied = 0;          
        document.querySelector(".minicart-msg-section")?.classList.add("d-none");
        document.querySelector(".offer-list-section ")?.classList.add("d-none"); 
      }else if(userLoggedIn && Array.isArray(customerData.tags) && !newContractId){
        document.querySelector(".minicart-msg-section")?.classList.remove("d-none");
        document.querySelector(".offer-list-section ")?.classList.remove("d-none"); 
      }

      document.querySelectorAll(".total-price-amount").forEach((el) => {
          el.textContent = this.formatMoney((totalwithshipping - offApplied) * 100);
      });
      this.updateTotalDiscountAmount(totalwithshipping, Number(offApplied) > 0);

      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }

      /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew);     

      this.getShippingAmount();

      console.log('codeLabel',codeLabel);
      console.log('offApplied',offApplied);
      console.log('totalDiscountPercent',totalDiscountPercent);

      if(codeLabel && (total_price >= MIN_OTP_CART_AMOUNT)){ 

        if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit) { 

        }else{ 

          if (typeof codeLabel === "string") {
            codeLabel = codeLabel
              .split(",")          // split by comma
              .map(v => v.trim())  // trim spaces
              .filter(Boolean)     // remove empty values
              .join(" + ");        // join
          }          
          
          this.showDiscountCodeRow({
            code: codeLabel,
            amount: offApplied,
            orderTypeHave: orderTypeNew
          });
        }


      }else{

        let extraRow = document.querySelector(".welcome25-extra-row");
        /*let discountSection = document.querySelector(".discount-section");        
        if (discountSection) {
          discountSection?.classList.add("d-none");
        }*/
        if (extraRow) {
          extraRow.remove();
        }

      }
  }
  

  subscriptionOffers({ original_total_price, items, total_count }, totalPrice, totalwithshipping) {
    const offerLists = document.querySelectorAll(".offer-list");
    const offerListDetails = document.getElementById("offer-list-details");
  
    document.querySelector(".free-shipping-section")?.classList.remove("d-none");
    this.getShippingAmount();
    document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    if (!offerLists) {
      console.error('Element with class "offer-list" not found');
      return;
    }
  
    const cartAmountInDollars = totalPrice;
    const mealsCount = this.countLunchAndDinnerMeals(items);

    let sdata_new = JSON.parse(localStorage.getItem("window_state") || "{}");

    let { promoOffer = "", contractId = "", orderNo } = JSON.parse(subscriptionContractId || "{}");

    let newContractId = contractId;
      
    const selectedMeal = document.querySelector('input[name="meal_style"]:checked');
    const mealStyle = selectedMeal.value;

    if(!newContractId){
      newContractId = this.getContractIdFromCache(sdata_new.email);
      console.log('newContractId1',newContractId);          
    }
      
    // console.log('cartAmountInDollars',cartAmountInDollars);
    // console.log('original_total_price',original_total_price);  
    // console.log('mealsCount',mealsCount);
    // console.log('MIN_SUBS_MEAL_LIMIT',MIN_SUBS_MEAL_LIMIT);
    // console.log('MIN_SUBS_CART_AMOUNT',MIN_SUBS_CART_AMOUNT);          
  
    if ((mealsCount < MIN_SUBS_MEAL_LIMIT) || (cartAmountInDollars < MIN_SUBS_CART_AMOUNT)) {
      if (primaryButton) {
        primaryButton.removeAttribute("onclick", "javascript:void(0);");
        primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
      }      
      
      let frist_have = 0;
      if (mealsCount < MIN_SUBS_MEAL_LIMIT){
        if (primaryButton) {
            primaryButton.innerHTML = `Add ${MIN_SUBS_MEAL_LIMIT - mealsCount} meals to reach the order minimum`;
        }
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
        frist_have = 1;
      } else{
        frist_have = 0;
      }
      
      if ((cartAmountInDollars < MIN_SUBS_CART_AMOUNT) && !frist_have){
        if (primaryButton) {
          primaryButton.innerHTML = `Add ${this.formatMoney((MIN_SUBS_CART_AMOUNT - cartAmountInDollars) * 100)} to reach the order minimum`;
        }
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      }
      
    } else if (!newContractId && userLoggedIn && !mealStyle) { 

        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Please select choose your goal`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        document.getElementById("continue_to_shipping").innerText = "Please select choose your goal";

      } else {
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      const deliveryDate = getCookie("expecting-delivery");
      if (primaryButton) {
        //if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.innerHTML = 'Checkout Now';
          primaryButton.classList.add("bg-orange", "border-orange");
        /*} else {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
          primaryButton.innerHTML = 'Select Delivery Date and Checkout';
        }*/
      }
    }
  
    let notificationMessage = "Save up to 15% on Meals";
    let activeOffer = null;
    const basePrice = cartAmountInDollars.toFixed(2);
  
    offerLists.forEach(list => (list.innerHTML = ""));
    if (offerListDetails) offerListDetails.innerHTML = "";
  
    let bestOffer = false;
    let validForCount = false;
    let totalDiscount = 0;
    let prevPromo = null;

    console.log(promotionalOffers);
  
    Object.entries(promotionalOffers).forEach(([promo, offer]) => {
      const { min, max } = offer.mealRange || {};
      totalDiscount = typeof offer.discounts === "number" ? `${offer.discounts}%OFF` : (promo === "promo1" ? "FREE SHIPPING" : offer.discounts);
      if (typeof totalDiscount !== "string" && Array.isArray(offer.discounts)) {
        totalDiscount = `$${Math.round(offer.discounts.reduce((a, b) => a + b, 0))}`;
      }
  
      const li = document.createElement("li");
      const isBestOffer = max === null ? mealsCount >= min : mealsCount >= max;
      li.classList.add("me-2", "d-flex", "align-items-center", "rounded-pill",
        isBestOffer ? "bg-gradient-success" : "bg-off-grey");
      bestOffer = isBestOffer;
      if (mealsCount >= min && (max === null || mealsCount < max)) {
        notificationMessage += `<br><span class="small text-muted fs-12">${offer.notify}</span>`;
        const maxRange = max === null ? Math.max(mealsCount, min) : max;
        const widthPercentage = maxRange > 0 ? Math.min((mealsCount / maxRange) * 100, 100) : 100;
  
        const progressDiv = document.createElement("div");
        progressDiv.classList.add("d-flex", "align-items-center", "justify-end", "rounded-pill", "bg-gradient-success-secondary");
        progressDiv.style.transition = "width 1s";
        progressDiv.style.minWidth = "max-content";
        progressDiv.style.zIndex = "1";
        progressDiv.style.width = `${widthPercentage}%`;
  
        const innerDiv = document.createElement("div");
        innerDiv.classList.add("d-flex", "align-items-center", "justify-center", "rounded-pill", "bg-white", "color-green", "border-green", "px-2", "dynamic-margin", "py-sm-0", "py-1");
        innerDiv.textContent = `${mealsCount}/${max === null ? "17+" : maxRange}`;
  
        progressDiv.appendChild(innerDiv);
        li.style.width = "100%";
        li.classList.add("position-relative", "bg-off-grey");
        li.appendChild(progressDiv);
  
        const span = document.createElement("span");
        span.classList.add("position-absolute", "right-0", "text-dark", "px-1", "py-sm-0", "py-1");
        span.textContent = totalDiscount;
        li.appendChild(span);
  
        if (prevPromo && typeof prevPromo.discounts === "number") {
          activeOffer = prevPromo;
        } else if (prevPromo?.discounts?.length) {
          activeOffer = prevPromo;
          prevPromo.discounts.forEach((discount, index) => {
            const discountContentDiv = document.createElement("div");
            discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
            const badgeSpan = document.createElement("span");
            badgeSpan.classList.add("badge", "bg-orange", "d-block", "mb-2", "position-absolute", "right-0", "small");
            badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
            const iconElement = document.createElement("i");
            iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
            const discountDiv = document.createElement("div");
            discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
            discountDiv.textContent = `${this.formatMoney(discount * 100)} off`;
            const dashDiv = document.createElement("div");
            dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
            discountContentDiv.append(badgeSpan, iconElement, discountDiv);
            offerListDetails?.append(discountContentDiv, dashDiv);
          });
        } else {
          const span = document.createElement("span");
          span.classList.add("fw-bold", "text-black", "py-2");
          span.textContent = "Save up to 15% on Meals";
          offerListDetails?.appendChild(span);
        }
      } else {
        const span = document.createElement("span");
        span.classList.add("rounded-pill", "top-0", "right-0", "text-dark", "p-1", "text-white", "text-center");
        span.textContent = totalDiscount;
        li.appendChild(span);
      }
  
      prevPromo = offer;
      offerLists.forEach(list => list.appendChild(li.cloneNode(true)));
    });

    let extraRow = document.querySelector(".welcome25-extra-row");
    let totalEls = document.querySelectorAll(".total-price-amount");
    let discountSectionPrev = document.querySelector(".discount-section");
    let offerListSection = document.querySelector(".offer-list-section");
    if (extraRow) extraRow.remove();    
    
    discountSectionPrev?.classList.remove('strick_through');
    offerListSection?.classList.remove('shadow_row');
  
    if (bestOffer) {
      this.renderlastOffer(promotionalOffers.promo3);
      offerLists.forEach(list => (list.innerHTML = ""));
      const li = document.createElement("li");
      li.classList.add("me-2", "d-flex", "align-items-center", "rounded-pill", "bg-gradient-success");
      li.style.width = "100%";
  
      const span = document.createElement("span");
      span.classList.add("px-2", "py-1", "rounded-pill", "top-0", "right-0", "text-dark", "p-1", "text-white", "text-center");
      span.textContent = `You’re saving 15% on Meals`;
      li.appendChild(span);
  
      activeOffer = promotionalOffers.promo3;
      offerLists.forEach(list => list.appendChild(li.cloneNode(true)));
    }

    if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit){      
      document.querySelector(".minicart-msg-section")?.classList.add("d-none");
      document.querySelector(".offer-list-section ")?.classList.add("d-none"); 
    }else if(userLoggedIn && Array.isArray(customerData.tags) && !newContractId){
      document.querySelector(".minicart-msg-section")?.classList.remove("d-none");
      document.querySelector(".offer-list-section ")?.classList.remove("d-none"); 
    }
  
    document.querySelector(".offer-details-bar")?.classList.remove("d-none");
  
    const minSubsN = typeof MIN_SUBS_MEAL_LIMIT !== "undefined" ? MIN_SUBS_MEAL_LIMIT : 10;
    const totalDiscountPercent = this.getApplicableDiscountPercent(mealsCount, typeof promotionalOffers !== "undefined" ? promotionalOffers : null, minSubsN);

    //let offApplied = (cartAmountInDollars * (totalDiscountPercent / 100)).toFixed(2);

    let lunchdinnerItems = this.cart.items.filter(item => item.product_type === "LUNCH & DINNER");
    
    let offApplied = 0;
    lunchdinnerItems.forEach(item => {
      let itemPrice = item.price;

      if (this.additionalpromo && typeof PROMO_PROD_PRICE !== 'undefined') {
        itemPrice = PROMO_PROD_PRICE;
      }

      let itemDiscount = (itemPrice / 100) * (totalDiscountPercent / 100);

      // floor to 2 decimal places
      let finalDiscount = Math.floor(itemDiscount * 100) / 100;

      offApplied += finalDiscount * item.qty;
      
    });
    offApplied = offApplied.toFixed(2);

    let discountedPrice = (totalwithshipping - offApplied).toFixed(2);
    const selectedOrderType = sdata_new?.freq || "WeeklySubscription";
    const shippingDeducted = this.isShippingDeductedForTotal(selectedOrderType, mealsCount);
    
    document.querySelectorAll(".total-price-amount").forEach(el => {
      el.textContent = this.formatMoney(discountedPrice * 100);
    });
    this.updateTotalDiscountAmount(totalwithshipping, Number(offApplied) > 0 || shippingDeducted, shippingDeducted);
  
    document.querySelector(".total-applied-section")?.classList.toggle("d-none", !activeOffer);
    document.querySelectorAll(".notification-message-mini-cart").forEach(el => {
      el.innerHTML = notificationMessage;
    });
  
    document.querySelector(".sub-total-section")?.classList.remove("d-none");
    document.querySelector(".sub-total-amount").textContent = this.formatMoney(totalwithshipping * 100);
  
    const discountSection = document.querySelector(".discount-section");
    const discountAmountEl = document.querySelector(".discount-amount");
  
    if (offApplied > 0) {
      discountSection?.classList.remove("d-none");
      discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
    } else {
      discountSection?.classList.add("d-none");
      discountAmountEl && (discountAmountEl.textContent = "");
    }

    /* Show Discount Code*/
    let subTotalNew = (original_total_price || 0) / 100;
    let totalNowNew = Number(totalPrice || 0);
    let cartDataNew = this.getCartData(); 
    let { attributes, total_price } = cartDataNew;
    let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
    let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

    // Decide code label
    let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

    console.log('codeLabel',codeLabel);
    console.log('offApplied',offApplied);

    if(codeLabel && (mealsCount >= 10)){ 
      if(userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit) { 
      }else{     
        if (typeof codeLabel === "string") {
          codeLabel = codeLabel
            .split(",")          // split by comma
            .map(v => v.trim())  // trim spaces
            .filter(Boolean)     // remove empty values
            .join(" + ");        // join
        } 
        this.showDiscountCodeRow({
          code: codeLabel,
          amount: offApplied,
          orderTypeHave: orderTypeNew
        });
      }
    }
  }

  
  renderlastOffer(prevPromo) {
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerListDetails || !prevPromo) return;
      if (typeof prevPromo.discounts === "number") {
        const discountContentDiv = document.createElement("div");
        discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
        const iconElement = document.createElement("i");
        iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
        const discountDiv = document.createElement("div");
        discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
        discountDiv.textContent = `${prevPromo.discounts}% off`;
        discountContentDiv.appendChild(iconElement);
        discountContentDiv.appendChild(discountDiv);
        offerListDetails.appendChild(discountContentDiv);
      } else if (Array.isArray(prevPromo.discounts)) {
        prevPromo.discounts.forEach((discount, index) => {
          const discountContentDiv = document.createElement("div");
          discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
          const badgeSpan = document.createElement("span");
          badgeSpan.classList.add("badge", "bg-orange", "d-block", "mb-2", "position-absolute", "right-0", "small");
          badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
          const iconElement = document.createElement("i");
          iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
          const discountDiv = document.createElement("div");
          discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
          discountDiv.textContent = `$${discount} off`;
          const dashDiv = document.createElement("div");
          dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
          discountContentDiv.appendChild(badgeSpan);
          discountContentDiv.appendChild(iconElement);
          discountContentDiv.appendChild(discountDiv);
          offerListDetails.appendChild(discountContentDiv);
          offerListDetails.appendChild(dashDiv);
        });
      }
  }

  KetoOneTimePurchaseOffers({
      original_total_price,
      original_keto_total_price,
      original_t1_total_price,
      original_t2_total_price,
      original_t3_total_price,
      items,
      item_count,
      total_count
  }, totalPrice, totalwithshipping) {
      const offerLists = document.querySelectorAll(".offer-list");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      document.querySelectorAll(".frequency-selector").forEach(el => el.remove());
    
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerListDetails) {
        //console.error('Element with id "offer-list-details" not found');
        //return;
      }      

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");
      
      if (extraRow) extraRow.remove();
      discountSectionPrev?.classList.remove('strick_through');
      offerListSection?.classList.remove('shadow_row');
    
      const cartAmountInDollars = totalPrice;
    
      if (cartAmountInDollars < MIN_OTP_CART_AMOUNT) {
        if (primaryButton) {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.remove("checkPostalBtn2", "bg-orange", "border-orange");
          primaryButton.innerHTML = `Add ${this.formatMoney((MIN_OTP_CART_AMOUNT - cartAmountInDollars) * 100)} to reach the order minimum`;
        }
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      } else {
        if (primaryButton) {
          const deliveryDate = getCookie("expecting-delivery");
          //if (deliveryDate !== null) {
            primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
            primaryButton.classList.add("bg-orange", "border-orange");
            primaryButton.innerHTML = "Checkout Now";
          /*} else {
            primaryButton.removeAttribute("onclick");
            primaryButton.classList.add("checkPostalBtn2");
            primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
            primaryButton.innerHTML = "Select Delivery Date and Checkout";
          }*/
        }
      }

      console.log('original_total_price', original_total_price);
      console.log('original_keto_total_price', original_keto_total_price);
      console.log('original_t1_total_price', original_t1_total_price);
      console.log('original_t2_total_price', original_t2_total_price);
      console.log('original_t3_total_price', original_t3_total_price);
      console.log('totalwithshipping', totalwithshipping);


      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")) {
        totalPrice = original_keto_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1")) {
        totalPrice = original_t1_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2")) {
        totalPrice = original_t2_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3")) {
        totalPrice = original_t3_total_price / 100;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && this.isBluefit) {
        totalPrice = original_total_price / 100;
      }
      const offApplied = (totalPrice - totalPrice).toFixed(2);
      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }
    
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-text")?.classList.add("d-none");
    
      document.querySelector(".sub-total-section")?.classList.remove("d-none");

      document.querySelector(".sub-total-amount").textContent = this.formatMoney(totalPrice * 100);
    
      document.querySelectorAll(".total-price-amount").forEach(el => {
        el.textContent = this.formatMoney(totalwithshipping * 100);
      });
      this.updateTotalDiscountAmount(totalwithshipping, false);

      /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

      console.log('codeLabel', codeLabel);
      console.log('offApplied', offApplied);
      console.log('orderTypeNew', orderTypeNew);

      this.getShippingAmount();

  }

  NDISoneTimePurchaseOffers({
      original_total_price,
      items
  }, totalPrice, totalwithshipping) {
    const cartAmountInDollars = (totalPrice).toFixed(2);
    //console.log(cartAmountInDollars, MIN_NDIS_OTP_CART_AMOUNT);
    const offerLists = document.querySelectorAll(".offer-list");
  
    document.querySelector(".total-applied-section")?.classList.add("d-none");
  
    document.querySelector(".free-shipping-section")?.classList.remove("d-none");
    document.querySelector(".free-shipping-text")?.classList.remove("d-none");
    document.querySelector(".free-shipping-amount")?.classList.add("text-decoration-line-through");
    //document.querySelector(".free-shipping-text")?.classList.remove("fw-bold");
  
    document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    const offerListDetails = document.getElementById("offer-list-details");
    if (!offerLists) {
      //console.error('Element with class "offer-list" not found');
      return;
    }
  
    // Conditional CTA button logic
    if (cartAmountInDollars < MIN_NDIS_OTP_CART_AMOUNT) { 
      if (primaryButton) {
        primaryButton.removeAttribute("onclick");
        primaryButton.classList.remove("checkPostalBtn2", "bg-orange", "border-orange");
        primaryButton.innerHTML = `Add ${this.formatMoney((MIN_NDIS_OTP_CART_AMOUNT - cartAmountInDollars) * 100)} to reach the order minimum`;
      }
  
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    } else {
      if (primaryButton) {
        const deliveryDate = getCookie("expecting-delivery");
  
        //if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.classList.add("bg-orange", "border-orange");
          primaryButton.innerHTML = "Checkout Now";
        /*} else {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
          primaryButton.innerHTML = "Select Delivery Date and Checkout";
        }*/
      }
    }

    let extraRow = document.querySelector(".welcome25-extra-row");
    let totalEls = document.querySelectorAll(".total-price-amount");
    let discountSectionPrev = document.querySelector(".discount-section");
    let offerListSection = document.querySelector(".offer-list-section");    
    if (extraRow) extraRow.remove();

    discountSectionPrev?.classList.remove('strick_through');
    offerListSection?.classList.remove('shadow_row');
  
    // Subtotal + Total price display
    document.querySelector(".sub-total-section")?.classList.remove("d-none");
    document.querySelector(".sub-total-amount").textContent = this.formatMoney(original_total_price);
  
     document.querySelectorAll(".total-price-amount").forEach((el) => {
            el.textContent = this.formatMoney(totalwithshipping * 100);
    });
    const discountSection = document.querySelector(".discount-section");
    const discountAmountEl = document.querySelector(".discount-amount");
    const offApplied = ((original_total_price/100) - totalPrice).toFixed(2);
    const shippingDeducted = this.isShippingDeductedForTotal("OneTimePurchase", this.countLunchAndDinnerMeals(items));
    this.updateTotalDiscountAmount(original_total_price / 100, Number(offApplied) > 0 || shippingDeducted, shippingDeducted);
    if (offApplied > 0) {
      discountSection?.classList.remove("d-none");
      discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
    } else {
      discountSection?.classList.add("d-none");
      discountAmountEl && (discountAmountEl.textContent = "");
    }

    /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

      console.log('codeLabel', codeLabel);
      console.log('offApplied', offApplied);
      console.log('orderTypeNew', orderTypeNew);
      console.log('totalPrice', totalPrice);

      this.getShippingAmount(false);

      codeLabel = (codeLabel || "")
      .split(",")
      .filter(c => c.trim() !== "NDIS-FREESHIPPING")
      .join(",");

      if(codeLabel && (totalPrice >= MIN_NDIS_OTP_CART_AMOUNT)){ 

        if (typeof codeLabel === "string") {
          codeLabel = codeLabel
            .split(",")          // split by comma
            .map(v => v.trim())  // trim spaces
            .filter(Boolean)     // remove empty values
            .join(" + ");        // or " " or "-" as you prefer
        } 
        this.showDiscountCodeRow({
          code: codeLabel,
          amount: offApplied,
          orderTypeHave: orderTypeNew
        });

      }
  }

  
  NDISsubscriptionOffers({
      original_total_price,
      items
  }, totalPrice, totalwithshipping) {
      
      const offerLists = document.querySelectorAll(".offer-list"); // Selects all elements with class 'offer-list'
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      let mealsCount = this.countLunchAndDinnerMeals(items);
      
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-text")?.classList.remove("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("text-decoration-line-through");
      //document.querySelector(".free-shipping-text")?.classList.remove('fw-bold');
      document.querySelector("#min-response")?.classList.remove("d-none");
      
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerLists) {
        //console.error('Element with id "offer-list" not found');
        return;
      }
      const cartAmountInDollars = totalPrice;
      if ((cartAmountInDollars < MIN_NDIS_SUBS_CART_AMOUNT) || (mealsCount < MIN_SUBS_MEAL_LIMIT)) {
        if (primaryButton) {
          //primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.removeAttribute("onclick", "javascript:void(0);");
          primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        }
        let frist_have = 0;
        if (mealsCount < MIN_SUBS_MEAL_LIMIT){
          if (primaryButton) {
              primaryButton.innerHTML = `Add ${MIN_SUBS_MEAL_LIMIT - mealsCount} meals to reach the order minimum`;
          }
          document.querySelector(".minimum-text-info")?.classList.add("d-none");
          frist_have = 1;
        } else{
          frist_have = 0;
        }
        
        if((cartAmountInDollars < MIN_NDIS_SUBS_CART_AMOUNT) && !frist_have){
          if (primaryButton) {
            primaryButton.innerHTML = `Add ${this.formatMoney((MIN_NDIS_SUBS_CART_AMOUNT - cartAmountInDollars) * 100)} to reach the order minimum`;
          }
          document.querySelector(".minimum-text-info")?.classList.add("d-none");
        }

        //console.log(mealsCount+' ===11 '+MIN_SUBS_MEAL_LIMIT);
        
        if (mealsCount < MIN_SUBS_MEAL_LIMIT){
          document.querySelector(".minimum-text-info")?.classList.add("d-none"); 
          //this._showMinResponse(`You need minimum ${MIN_SUBS_MEAL_LIMIT} meals to subscribe`, primaryButton);
        } 
        
      } else {
        
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
        //console.log(mealsCount+' ===12 '+MIN_SUBS_MEAL_LIMIT);        
        
        if (primaryButton) {
          const deliveryDate =  getCookie("expecting-delivery");
          //if (deliveryDate !== null) {
              primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
              primaryButton.innerHTML = 'Checkout Now';
              primaryButton.classList.add("bg-orange","border-orange");
          /*} else {
              primaryButton.removeAttribute("onclick");
              primaryButton.classList.add("checkPostalBtn2");
              primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
              primaryButton.innerHTML = 'Select Delivery Date and Checkout';
          }*/
        }
      }

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");
      
      if (extraRow) extraRow.remove();
      discountSectionPrev?.classList.remove('strick_through');
      offerListSection?.classList.remove('shadow_row');

      document.querySelector(".sub-total-section")?.classList.remove("d-none");
      document.querySelector(".sub-total-amount").textContent = this.formatMoney(original_total_price);
     
      document.querySelectorAll(".total-price-amount").forEach((el) => {
              el.textContent = this.formatMoney(totalwithshipping * 100);
      });
      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      const offApplied = ((original_total_price/100) - totalPrice).toFixed(2);
      const selectedOrderType = JSON.parse(localStorage.getItem("window_state") || "{}")?.freq || "WeeklySubscription";
      const shippingDeducted = this.isShippingDeductedForTotal(selectedOrderType, mealsCount);
      this.updateTotalDiscountAmount(original_total_price / 100, Number(offApplied) > 0 || shippingDeducted, shippingDeducted);
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-${this.formatMoney(offApplied * 100)}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }
      /* Show Discount Code*/
      let subTotalNew = (original_total_price || 0) / 100;
      let totalNowNew = Number(totalPrice || 0);
      let cartDataNew = this.getCartData(); 
      let { attributes, total_price } = cartDataNew;
      let attrs = JSON.parse(localStorage.getItem("cartAttributes") || "{}");
      let orderTypeNew = state.freq ? state.freq : (attrs?.orderType?.type ?? "WeeklySubscription");

      // Decide code label
      let codeLabel = this.applicableDiscount(cartDataNew, orderTypeNew); 

      console.log('codeLabel', codeLabel);
      console.log('offApplied', offApplied);
      console.log('orderTypeNew', orderTypeNew);
      console.log('totalPrice', totalPrice);
      console.log('mealsCount', mealsCount);

      codeLabel = (codeLabel || "")
      .split(",")
      .filter(c => c.trim() !== "NDIS-FREESHIPPING")
      .join(",");

      this.getShippingAmount();

      if(codeLabel && (mealsCount >= 10)){
        if (typeof codeLabel === "string") {
          codeLabel = codeLabel
            .split(",")          // split by comma
            .map(v => v.trim())  // trim spaces
            .filter(Boolean)     // remove empty values
            .join(" + ");        // or " " or "-" as you prefer
        } 
        //alert(codeLabel);
        this.showDiscountCodeRow({
          code: codeLabel,
          amount: offApplied,
          orderTypeHave: orderTypeNew
        });
      }
  }


  // -----------------------------
  // DISCOUNT APPLY / REMOVE (Shopify)
  // -----------------------------
  async applyDiscountCode(code) {
    if (!code) return false;
    try {
      // Shopify discount apply endpoint
      await fetch(`/discount/${encodeURIComponent(code)}`, {
        method: "GET",
        credentials: "same-origin",
      });

      if (String(code).toUpperCase() === "WELCOME25") {
        localStorage.removeItem("WELCOME25_REMOVED");
      }

      await this.overwriteFromRemoteCart(); // sync local cart
      this.updateCartInfoFromLocal(".cart-item-loop", 1);
      return true;
    } catch (e) {
      console.error("applyDiscountCode error:", e);
      return false;
    }
  }

  async removeDiscountCode(code) {
    if (!code) return false;
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          discount: ""
        })
      });

      const cart = await res.json();
      console.log("Discount removed", cart);
      
      localStorage.removeItem("WELCOME25_APPLIED");        
      console.log("Discount removed WELCOME25");

      location.reload(); // optional

    } catch (err) {
      console.error("Error removing discount:", err);
    }
  }

  // -----------------------------
  // Convert your applicableDiscount() → codes array
  // -----------------------------
  getApplicableCodesArray(cartData, orderType) {
    const raw = this.applicableDiscount(cartData, orderType); // may be null or "CODE1,CODE2,"
    if (!raw) return [];
    return String(raw)
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  }

}

const localCart = new LocalCart;


function getLocalCartItemByVarId(variantId, allItems) {
  if (!variantId) return null;
  const vId = Number(variantId);
  return (allItems || []).find(
    item => Number(item.variant_id) === vId
  ) || null;
}  

// Open your modal with message (simple)
function openQtyLimitModal(message) {
  const modal = document.getElementById("myModalQty");
  if (!modal) {
    alert(message); // fallback
    return;
  }
  const p = modal.querySelector(".modal-contentxxxx p");
  if (p) p.textContent = message;
  modal.style.display = "flex";
}

document.addEventListener("click", async (e) => {
  // Remove WELCOME25
  const removeBtn = e.target.closest(".remove-welcome25");
  if (removeBtn) {
    e.preventDefault();
    await localCart.removeDiscountCode("WELCOME25");
  }
});


async function checkWELCOME25FromCart() {
  const loader = document.getElementById("loading-screen");
  if (loader) {
    loader.style.display = "block";
  }

  try {

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    console.log(cart.discount_codes);

    // Check discount_codes
    const hasWELCOME25 = cart.discount_codes?.some(
      d => d.code?.toUpperCase() === "WELCOME25"
    );
    let WELCOME25_A = localStorage.getItem("WELCOME25_APPLIED");

    if (hasWELCOME25 && !localCart.isExcluded_Global) {
      if (WELCOME25_A != "1") {
        localStorage.setItem("WELCOME25_APPLIED", "1");
        await applyDiscountCodeOnlyWELCOME25();        
        console.log("Applied WELCOME25");
      }
      localCart.updateCartInfoFromLocal(".cart-item-loop");
    } else {
      if(hasWELCOME25){
        localCart.removeDiscountCode('WELCOME25');
        localStorage.removeItem("WELCOME25_APPLIED");        
        console.log("Discount removed WELCOME25");
      }
      localCart.updateCartInfoFromLocal(".cart-item-loop");
    }

  } catch (e) {

    console.error(e);

    return false;
  } finally {
    if (loader) {
      loader.style.display = "none";
    }
  }
}


async function applyDiscountCodeOnlyWELCOME25() {

  try {

    // Remove all current discounts
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        discount: ""
      })
    });

  } catch (e) {

    console.error("applyDiscountCodeOnlyWELCOME15 error:", e);

  }
}

async function ensureWelcome15Only() {
    const REQUIRED_CODE = 'WELCOME15';
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      // 1️⃣ check discount_codes
      const codeApplied = (cart.discount_codes || []).some(
        d => String(d?.code || "").toUpperCase() === "WELCOME25" && d?.applicable
      );

      // 2️⃣ check cart_level_discount_applications for amount
      const app = (cart.cart_level_discount_applications || []).find(
        a => String(a?.title || a?.code || "").toUpperCase() === "WELCOME25"
      );

      const amountCents = app?.total_allocated_amount || 0;

      if(!(codeApplied || (amountCents > 0))){
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            discount: ""
          })
        });

        const cart = await res.json();
        console.log("Discount removed New", cart);
      }

    } catch (e) {
      console.error("WELCOME25 check error:", e);
      return { applied: false, amountCents: 0 };
    }
}

function getEmailCacheNew() {
  try {
    return JSON.parse(localStorage.getItem('email_check_cache')) || {};
  } catch {
    return {};
  }
}

function getCustomerDataFromCache(email) {

  const cache = getEmailCacheNew();
  const entry = cache[email];

  if (!entry) return null;

  // ✅ 1 minute check
  const minutesPassed =
    (Date.now() - entry.checkedAt) / 1000 / 60;

  const isExpired = minutesPassed > 1;

  return isExpired ? null : entry.data;
}

function getSubscriptionStatusFromCache(email) {
  const data = getCustomerDataFromCache(email);

  if (!data || !data.subscriptions?.is_available) return null;

  if (data.subscriptions.is_active?.length) return "active";
  if (data.subscriptions.is_paused?.length) return "paused";
  if (data.subscriptions.is_cancelled?.length) return "cancelled";

  return null;
}

function getSubscriptionFromCache(email) {
  try {
    const cache = JSON.parse(localStorage.getItem(EMAIL_CACHE_KEY) || "{}");
    const data = cache[email]?.data;

    if (!data || !data.subscriptions) return null;

    // ✅ priority: active → paused
    if (Array.isArray(data.subscriptions.is_active) && data.subscriptions.is_active.length > 0) {
      return true;
    }

    if (Array.isArray(data.subscriptions.is_paused) && data.subscriptions.is_paused.length > 0) {
      return false;
    }

    return false;

  } catch (e) {
    console.error("Error getting subscription status:", e);
    return false;
  }
}


document.addEventListener("DOMContentLoaded", function () {

  const ref = document.referrer || "";
  const cameFromCheckout = ref.includes("/checkout");

  if (cameFromCheckout) {
      location.reload();
  } 

  const sub_cart_added = localStorage.getItem("sub_cart_added");
  const path = window.location.pathname.toLowerCase();

  console.log('subscriptionContractId',subscriptionContractId);
  console.log('userLoggedIn',userLoggedIn);

  
  if (userLoggedIn) {
    let new_state = JSON.parse(localStorage.getItem("window_state") || "{}");
    const email = new_state.email || (typeof customerData !== 'undefined' ? customerData.email : "");

    if (email) {
      localCart.overwriteFromSubscriptionCache(email).then(newCart => {
        // If we found a subscription, newCart will have items
        const hasActiveSub = newCart && Array.isArray(newCart.items) && newCart.items.length > 0;

        console.log('hasActiveSub',hasActiveSub);

        localCart.updateCartInfoFromLocal(".cart-item-loop");

        if (hasActiveSub) {
          // Point E: subscription user
          localStorage.setItem("sub_cart_added", "1");                 
          document.querySelector("#pre_selected_data").style.display = "none";
          document.querySelector("#pre_selected_data_wrap").style.display = "none";

        } else {

          // Point D: no active subscription
          localCart.updateReorderBox(); 
          document.querySelector("#pre_selected_data").style.display = "block";
          document.querySelector("#pre_selected_data_wrap").style.display = "block";

        }

      });

    } else {

      localCart.updateCartInfoFromLocal(".cart-item-loop");

    }
  } else {

      if (frequencySelect.value === "OneTimePurchase") {
        
      }else{

        localCart.updateCartInfoFromLocal(".cart-item-loop");

      }
  }
  const isKetoUser = userLoggedIn && customerData?.tags?.includes("keto_customers") && typeof customerData?.ketoCustDiscountFixed === "number";
  
  if (!frequencySelect) return;
  
  frequencySelect.addEventListener("change", function () {
    const selectedValue = frequencySelect.value;
    if (selectedValue === "OneTimePurchase") {
      document.querySelector("#min-response")?.classList.add("d-none");
    }
  });
  
  if(isKetoUser){    
    frequencySelect.value = "OneTimePurchase";
    const changeEvent = new Event("change", { bubbles: true });
    frequencySelect.dispatchEvent(changeEvent);  
    document.querySelector(".frequency-selector")?.classList.add("d-none"); // ⬅️ Hides the dropdown
    document.querySelector("#min-response")?.classList.add("d-none");
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const btn = document.getElementById("continue_to_reorder");

  if (!btn) return;

  btn.addEventListener("click", function () {
    localCart.handleReorderClick(); // 👈 class method
  });

});

document.querySelectorAll('input[name="meal_style"]').forEach(input => {
  input.addEventListener("change", function () {

    // remove active from all
    document.querySelectorAll(".meal-tag").forEach(tag => {
      tag.classList.remove("active");
    });

    // add active to selected
    this.closest(".meal-tag").classList.add("active");
    
    localCart.updateCartInfoFromLocal(".cart-item-loop");

  });
});


$(document).on("click", ".product-quantity .qtybutton", function() {
  const allItems = localCart.cart.items;

  const $button = $(this),
      action = $button.data("action"),
      $qtySpan = $button.siblings(".cusqtyspan"),
      oldQty = parseInt($qtySpan.text(), 10),
      newQty = action === "+" ? oldQty + 1 : Math.max(0, oldQty - 1);
  
  const $productQuantity = $button.closest(".product-quantity"),
      variantId = parseInt($productQuantity.data("variant"), 10),
      quantityElement = $button.siblings(".cusqtyspan");
  //console.log(allItems);
  if(allItems.length > 0){
    const itemFc = getLocalCartItemByVarId(variantId, allItems);
    console.log(itemFc);
    let enabled = false;
    if(itemFc.qty_limit_enabled){
      enabled = itemFc.qty_limit_enabled === true || itemFc.qty_limit_enabled === "true" || itemFc.qty_limit_enabled === 1 || itemFc.qty_limit_enabled === "1";
    }else{
      enabled = false;
    }

    if (enabled) {
      const max = Number(itemFc.max_qty_per_order);

      if (enabled) {
        // ✅ show popup only if user tries to exceed max
        if ((newQty > max) && (Number.isFinite(max) && (max >= 1))) {
          openQtyLimitModal(`Maximum of ${max} units per order for this item.`);
          return; // ⛔ STOP
        }
      }

    }
  }
  
  console.log(newQty+' ===');
  $qtySpan.html(newQty);
  $button.siblings("input").val(newQty);
    $productQuantityAction = $button.closest(".product-quantity-action");  
    localCart.changeInToLocalCart(variantId, newQty, $productQuantityAction);
    localCart.updateCartInfoFromLocal(".cart-item-loop");
});

document.addEventListener("DOMContentLoaded", () => {
  const getCart = localCart.getCartData();
  const orderType = getCart?.attributes?.orderType?.type;
  if (orderType) {
    if (frequencySelect) {
      frequencySelect.value = orderType;
    }
  }
});


function changeInToCart(variantId, quantity, quantityElement=null, $productQuantityAction=null,  localCart=null) {
    $productQuantityAction?.addClass('loading');
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: quantity,
            id: variantId
        },
        success: function(data) {
          $productQuantityAction?.removeClass('loading');
          localCart.updateCartInfoFromLocal(".cart-item-loop");
        },
        error: function(error) {
            console.error("Error adding to cart: ", error);
           if (quantityElement) {
              quantityElement.text(quantityElement.data('original-value')); // Revert to original value on error
          }
           $productQuantityAction?.removeClass('loading');
        }
    });
}

function clearCartData() {
  return fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(clearCart => {
      // console.log('Success:', clearCart);
      localCart.updateCartInfoFromLocal(".cart-item-loop");
      localStorage.removeItem("contractInfo");
      window.location.href = `/collections/fresh-ready-meals`;
    })
    .catch((error) => {
      console.error("Error clearing cart:", error);
      throw error; // Rethrow the error for further handling
    });
}

function applyShippingAmount(appiled = true) {
  const statenew = JSON.parse(localStorage.getItem("window_state") || "{}");
  const locaDelInit = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

  let shipping_amount = localStorage.getItem("shipping_amount") || 0;
  let selected_frequency = statenew?.freq;

  let amountEl = document.querySelector(".free-shipping-amount");
  let freeTextEl = document.querySelector(".free-shipping-text");
  let deliveryShippingEl = document.querySelector(".delivery-text-shippingamount");

  if (!amountEl) return;

  const format = (cents) => localCart.formatMoney(cents);
  const defaultShippingCents = 1500; // $15.00 default
  const currentShippingCents = Math.round(parseFloat(shipping_amount || 0) * 100);
  const mealsCount = localCart.countLunchAndDinnerMeals(localCart.cart.items);

  const hasAddress = !!(
    statenew?.address && String(statenew.address).trim() !== ""
  );

  const setShippingText = (text) => {
    amountEl.textContent = text;
  };

  amountEl.classList.add("fw-bold");

  // ✅ Address blank হলে shipping Pending দেখাবে
  if (!hasAddress) {
    
    if(selected_frequency != "OneTimePurchase"){
      if(mealsCount < 10){
        setShippingText("Pending");
        amountEl.classList.remove("free_amount");
      }else{      
        setShippingText("Free");
        amountEl.classList.add("free_amount");        
      }
    }else{          
      setShippingText("Pending");
      amountEl.classList.remove("free_amount");
    }

    amountEl.classList.remove("text-decoration-line-through");

    if (deliveryShippingEl) {
      deliveryShippingEl.textContent = "Pending";
    }

    if (freeTextEl) {
      freeTextEl.classList.add("d-none");
    }
    return;

  }else{  

    if (deliveryShippingEl) {
      deliveryShippingEl.textContent = format(currentShippingCents || defaultShippingCents);
    }

  }

  if (selected_frequency === "OneTimePurchase") {

    setShippingText(format(currentShippingCents || defaultShippingCents));

    amountEl.classList.remove("free_amount");
    amountEl.classList.remove("text-decoration-line-through");

    if (freeTextEl) {
      freeTextEl.classList.add("d-none");
    }

  } else if ( selected_frequency === "WeeklySubscription" || selected_frequency === "FortnightlySubscription" ) {


    if (mealsCount < 10) {
      setShippingText(format(currentShippingCents || defaultShippingCents));

      amountEl.classList.remove("text-decoration-line-through");
      amountEl.classList.remove("free_amount");

      if (freeTextEl) {
        freeTextEl.classList.add("d-none");
      }

    } else {
      
      setShippingText("$0.00");

      amountEl.classList.add("free_amount");
      amountEl.classList.remove("text-decoration-line-through");

      if (freeTextEl) {
        freeTextEl.textContent = format(currentShippingCents || defaultShippingCents);
        freeTextEl.classList.remove("d-none");
        freeTextEl.classList.add(
          "text-decoration-line-through",
          "text",
          "ms-1"
        );
        freeTextEl.classList.remove("text-grren", "text-uppercase");
      }
    }

  } else {
    setShippingText("$0.00");

    amountEl.classList.add("free_amount");
    amountEl.classList.remove("text-decoration-line-through");

    if (freeTextEl) {
      freeTextEl.textContent = format(defaultShippingCents);
      freeTextEl.classList.remove("d-none");
      freeTextEl.classList.add(
        "text-decoration-line-through",
        "text",
        "ms-1"
      );
      freeTextEl.classList.remove("text-grren", "text-uppercase");
    }
  }
}


/* ------------------------------------------------------------------
   Checkout validator (custom page → Shopify checkout)
   - Validates email, phone, address, delivery date/time, plan(+freq)
   - Saves: cartAttributes, deliveryInfo, widgetAddress
   - Calls: localCart.continueToShipping(requestPath)
  ------------------------------------------------------------------- */
  window.checkoutValidate = function checkoutValidate(requestPath = "mini-cart") {
    const vEmail = v => /\S+@\S+\.\S+/.test(String(v||""));
    const vPhone = v => String(v||"").replace(/\D/g,"").length >= 8;
    const vAddr  = v => String(v||"").trim().length >= 6;
    const qs     = (s, r=document) => r.querySelector(s);
    
    const window_state   = JSON.parse(localStorage.getItem("window_state")   || "{}");

    // read from your global `state` first; fall back to DOM fields
    const email   = (window.state?.email   || (qs("#email2")?.value || qs("#email1")?.value || "")).trim();
    //const phone   = (window.state?.phone   || (qs("#phone2")?.value || qs("#phone1")?.value || "")).trim();
    const address = (window.state?.address || (qs("#address2")?.value || qs("#address1")?.value || "")).trim();

    const dateStr = (window.state?.date || (window_state?.date || "")).trim();
    const timeStr = (window.state?.time || (window_state?.time || "")).trim();
    const plan    = (window.state?.plan || (window_state?.plan || "")).trim();           // "subscribe" | "onetime"
    const freq    = (window.state?.freq || (window_state?.freq || "")).trim();           // "weekly" | "fortnightly" | ""

    //if (!vEmail(email))  { alert("Please enter a valid email."); return false; }
    /*if (!vPhone(phone))  { alert("Please enter a valid phone number (min 8 digits)."); return false; }
    if (!vAddr(address)) { alert("Please enter a valid delivery address."); return false; }
    if (!dateStr)        { alert("Please select a delivery date."); return false; }
    if (!timeStr)        { alert("Please select a delivery time slot."); return false; }
    if (!plan)           { alert("Please select a plan (Subscribe & Save or One-Time)."); return false; }
    if (plan === "subscribe" && !freq) {
      alert("Please choose Weekly or Fortnightly for your subscription."); return false;
    }*/

    // Normalize to theme’s expected values
    const orderType =
      plan === "subscribe"
        ? (freq === "WeeklySubscription" ? "WeeklySubscription" : "FortnightlySubscription")
        : "OneTimePurchase";



    // Helpers to parse the UI’s date/time formats into what createFormData expects
    const parseDeliveryDate = (label) => {
      const m = /\(([^)]+)\)$/.exec(String(label));
      return m ? m[1] : String(label || "");
    };
    const parseTimeSlot = (slot) => {
      const parts = String(slot).split(/–|-/).map(s => s.trim());
      const pad = s => {
        const [h,m="00"] = s.split(":");
        return `${String(h).padStart(2,"0")}:${m}`;
      };
      return parts.length === 2 ? [pad(parts[0]), pad(parts[1])] : ["",""];
    };

    const deliveryDate = parseDeliveryDate(dateStr);
    const [deliveryStart, deliveryEnd] = parseTimeSlot(timeStr);

    // Persist info for LocalCart pipeline
    localStorage.setItem("cartAttributes", JSON.stringify({ orderType: { type: orderType } }));

    // Best-effort AU postcode extraction for validatedAddress()
    const postcodeMatch = address.match(/\b(\d{4})\b(?!.*\b\d{4}\b)/);

    // Keep window.state in sync (optional)
    window.state = Object.assign({}, window.state, {
    email, address, date: dateStr, time: timeStr, plan, freq
    });

    localCart.updateCartInfoFromLocal(".cart-item-loop");
    
  };

  document.addEventListener("DOMContentLoaded", function () {
    applyDiscountCodeOnlyWELCOME25();
    localCart.updateCartInfoFromLocal(".cart-item-loop");
    document.getElementById("toPlan").disabled = true;
  });